// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var $$String = require("rescript/lib/js/string.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Belt_SetString = require("rescript/lib/js/belt_SetString.js");
var FastLevenshtein = require("fast-levenshtein");
var Log$SmartcutsMacros = require("../../bs-macros-extension/src/Log.bs.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var Webapi__Dom__Element = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Element.bs.js");
var XPath$SmartcutsMacros = require("../../bs-macros-extension/src/XPath.bs.js");
var Selector$SmartcutsMacros = require("../../bs-macros-extension/src/Selector.bs.js");
var HTMLNodes$SmartcutsMacros = require("./HTMLNodes.bs.js");
var ListUtils$SmartcutsMacros = require("../../bs-utils/src/ListUtils.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var Exceptions$SmartcutsMacros = require("../../bs-macros-extension/src/Exceptions.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");
var DOM__Element$SmartcutsMacros = require("../../bs-macros-extension/src/DOM__Element.bs.js");
var PromiseUtils$SmartcutsMacros = require("../../bs-utils/src/PromiseUtils.bs.js");
var SelectorTree$SmartcutsMacros = require("./SelectorTree.bs.js");
var DOM__Document$SmartcutsMacros = require("../../bs-macros-extension/src/DOM__Document.bs.js");
var ComboGenerator$SmartcutsMacros = require("./ComboGenerator.bs.js");
var DataDependency$SmartcutsMacros = require("../../bs-macros-extension/src/commands/shared/DataDependency.bs.js");
var DevProtocol__DOM$SmartcutsMacros = require("../../bs-macros-extension/src/devProtocol/DevProtocol__DOM.bs.js");

function candidateBranch_encode(v) {
  return Js_dict.fromArray([
              [
                "branch",
                Decco.arrayToJson(DevProtocol__DOM$SmartcutsMacros.nodeId_encode, v.branch)
              ],
              [
                "distanceComponents",
                Decco.arrayToJson(Decco.floatToJson, v.distanceComponents)
              ]
            ]);
}

function candidateBranch_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var branch = Decco.arrayFromJson(DevProtocol__DOM$SmartcutsMacros.nodeId_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "branch"), null));
  if (branch.TAG === /* Ok */0) {
    var distanceComponents = Decco.arrayFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "distanceComponents"), null));
    if (distanceComponents.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                branch: branch._0,
                distanceComponents: distanceComponents._0
              }
            };
    }
    var e = distanceComponents._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".distanceComponents" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = branch._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".branch" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function MakeQueryInPromise(RunTime) {
  var doesElementMatchFullInnerText = function (fullTextToMatch, context, compareFullInnerTextToExpectedFullInnerText, compareTruncatedInnerTextToExpectedFullInnerText, addCancelCallback, element) {
    var match = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, isCanceled) {
          if (isCanceled.contents) {
            throw {
                  RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                  Error: new Error()
                };
          }
          return Curry._3(RunTime.getInnerTextForElement, context, addCancelCallback, element);
        });
    Curry._1(addCancelCallback, match[1]);
    return Curry._1(match[0], undefined).then(function (innerText) {
                var tmp;
                if (typeof innerText === "number") {
                  tmp = innerText === /* Ignored */0 ? true : false;
                } else if (innerText.TAG === /* FullInnerText */0) {
                  var normalizedText = $$String.lowercase_ascii(innerText._0.trim());
                  var normalizedExpectedText = $$String.lowercase_ascii(fullTextToMatch.trim());
                  tmp = Curry._2(compareFullInnerTextToExpectedFullInnerText, normalizedText, normalizedExpectedText);
                } else {
                  var prefix = innerText._0;
                  var normalizedPrefix = $$String.lowercase_ascii(prefix.trim());
                  tmp = Curry._3(compareTruncatedInnerTextToExpectedFullInnerText, normalizedPrefix, innerText._1 - (prefix.length - normalizedPrefix.length | 0) | 0, $$String.lowercase_ascii(fullTextToMatch.trim()));
                }
                return Promise.resolve(tmp);
              });
  };
  var doesElementMatchInnerText = function (maybeUseInnerTextExactMatch, maybeInnerTextSemantic, context, compareFullInnerTextToExpectedFullInnerText, compareFullInnerTextToExpectedTruncatedInnerText, compareTruncatedInnerTextToExpectedFullInnerText, compareTruncatedInnerTextToExpectedTruncatedInnerText, addCancelCallback, element) {
    if (maybeUseInnerTextExactMatch === undefined) {
      return Promise.resolve(true);
    }
    if (typeof maybeUseInnerTextExactMatch === "number") {
      if (maybeUseInnerTextExactMatch === /* Ignored */0) {
        if (maybeInnerTextSemantic === undefined) {
          return Promise.resolve(true);
        }
        if (typeof maybeInnerTextSemantic !== "number" && maybeInnerTextSemantic.TAG === /* VariableInnerText */5) {
          return Promise.resolve(true);
        }
        
      } else if (maybeInnerTextSemantic !== undefined) {
        if (typeof maybeInnerTextSemantic !== "number" && maybeInnerTextSemantic.TAG === /* VariableInnerText */5) {
          return Promise.resolve(false);
        }
        
      } else {
        var match = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, isCanceled) {
              if (isCanceled.contents) {
                throw {
                      RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                      Error: new Error()
                    };
              }
              return Curry._3(RunTime.getInnerTextForElement, context, addCancelCallback, element);
            });
        Curry._1(addCancelCallback, match[1]);
        return Curry._1(match[0], undefined).then(function (innerText) {
                    var tmp;
                    tmp = typeof innerText === "number" ? true : innerText._0 === "";
                    return Promise.resolve(tmp);
                  });
      }
    } else if (maybeUseInnerTextExactMatch.TAG === /* FullInnerText */0) {
      var fullTextToMatch = maybeUseInnerTextExactMatch._0;
      if (maybeInnerTextSemantic === undefined) {
        return doesElementMatchFullInnerText(fullTextToMatch, context, compareFullInnerTextToExpectedFullInnerText, compareTruncatedInnerTextToExpectedFullInnerText, addCancelCallback, element);
      }
      if (typeof maybeInnerTextSemantic !== "number" && maybeInnerTextSemantic.TAG === /* VariableInnerText */5) {
        return doesElementMatchFullInnerText(fullTextToMatch, context, compareFullInnerTextToExpectedFullInnerText, compareTruncatedInnerTextToExpectedFullInnerText, addCancelCallback, element);
      }
      
    } else {
      var prefixToMatch = maybeUseInnerTextExactMatch._0;
      if (maybeInnerTextSemantic !== undefined) {
        if (typeof maybeInnerTextSemantic !== "number" && maybeInnerTextSemantic.TAG === /* VariableInnerText */5) {
          return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected pairing with VariableInnerText: " + HTMLNodes$SmartcutsMacros.InnerText.stringify(maybeUseInnerTextExactMatch));
        }
        
      } else {
        var normalizedPrefixToMatch = $$String.lowercase_ascii(prefixToMatch.trim());
        var normalizedOriginalLength = maybeUseInnerTextExactMatch._1 - (prefixToMatch.length - normalizedPrefixToMatch.length | 0) | 0;
        var match$1 = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, isCanceled) {
              if (isCanceled.contents) {
                throw {
                      RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                      Error: new Error()
                    };
              }
              return Curry._3(RunTime.getInnerTextForElement, context, addCancelCallback, element);
            });
        Curry._1(addCancelCallback, match$1[1]);
        return Curry._1(match$1[0], undefined).then(function (innerText) {
                    var tmp;
                    if (typeof innerText === "number") {
                      tmp = innerText === /* Ignored */0 ? true : false;
                    } else if (innerText.TAG === /* FullInnerText */0) {
                      var normalizedFullText = $$String.lowercase_ascii(innerText._0.trim());
                      tmp = Curry._3(compareFullInnerTextToExpectedTruncatedInnerText, normalizedFullText, normalizedPrefixToMatch, normalizedOriginalLength);
                    } else {
                      var prefix2 = innerText._0;
                      var normalizedPrefix2 = $$String.lowercase_ascii(prefix2.trim());
                      var normalizedLength2 = innerText._1 - (prefix2.length - normalizedPrefix2.length | 0) | 0;
                      tmp = Curry._4(compareTruncatedInnerTextToExpectedTruncatedInnerText, normalizedPrefix2, normalizedLength2, normalizedPrefixToMatch, normalizedOriginalLength);
                    }
                    return Promise.resolve(tmp);
                  });
      }
    }
    if (typeof maybeInnerTextSemantic === "number") {
      return Promise.resolve(true);
    }
    switch (maybeInnerTextSemantic.TAG | 0) {
      case /* MatchesFullInnerText */0 :
          var fullTextToMatch$1 = Curry._1(DataDependency$SmartcutsMacros.DataRef.resolveAsText, maybeInnerTextSemantic._0);
          return doesElementMatchFullInnerText(fullTextToMatch$1, context, compareFullInnerTextToExpectedFullInnerText, compareTruncatedInnerTextToExpectedFullInnerText, addCancelCallback, element);
      case /* MatchesInnerTextPrefix */1 :
          var stringThatShouldPrefixInnerText = Curry._1(DataDependency$SmartcutsMacros.DataRef.resolveAsText, maybeInnerTextSemantic._0);
          var match$2 = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, isCanceled) {
                if (isCanceled.contents) {
                  throw {
                        RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                        Error: new Error()
                      };
                }
                return Curry._3(RunTime.getInnerTextForElement, context, addCancelCallback, element);
              });
          Curry._1(addCancelCallback, match$2[1]);
          return Curry._1(match$2[0], undefined).then(function (innerText) {
                      var tmp;
                      if (typeof innerText === "number") {
                        tmp = innerText === /* Ignored */0 ? true : false;
                      } else if (innerText.TAG === /* FullInnerText */0) {
                        tmp = innerText._0.startsWith(stringThatShouldPrefixInnerText);
                      } else {
                        var prefix = innerText._0;
                        if (prefix.length > stringThatShouldPrefixInnerText.length) {
                          tmp = prefix.includes(stringThatShouldPrefixInnerText);
                        } else {
                          var truncatedStringThatShouldPrefixInnerText = stringThatShouldPrefixInnerText.slice(0, prefix.length);
                          tmp = truncatedStringThatShouldPrefixInnerText === prefix && truncatedStringThatShouldPrefixInnerText.length <= innerText._1;
                        }
                      }
                      return Promise.resolve(tmp);
                    });
      case /* ContainsInnerText */2 :
          var stringThatShouldBeInsideInnerText = Curry._1(DataDependency$SmartcutsMacros.DataRef.resolveAsText, maybeInnerTextSemantic._0);
          var match$3 = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, isCanceled) {
                if (isCanceled.contents) {
                  throw {
                        RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                        Error: new Error()
                      };
                }
                return Curry._3(RunTime.getInnerTextForElement, context, addCancelCallback, element);
              });
          Curry._1(addCancelCallback, match$3[1]);
          return Curry._1(match$3[0], undefined).then(function (innerText) {
                      var tmp;
                      if (typeof innerText === "number") {
                        tmp = innerText === /* Ignored */0 ? true : false;
                      } else if (innerText.TAG === /* FullInnerText */0) {
                        tmp = innerText._0.includes(stringThatShouldBeInsideInnerText);
                      } else {
                        var prefix = innerText._0;
                        if (prefix.length > stringThatShouldBeInsideInnerText.length) {
                          tmp = prefix.includes(stringThatShouldBeInsideInnerText);
                        } else {
                          console.warn("Unhandled ContainsInnerText against TruncatedInnerText");
                          tmp = false;
                        }
                      }
                      return Promise.resolve(tmp);
                    });
      case /* ContainsInnerTextEnum */3 :
          var possibleMatchingSubstrings = $$Array.append([
                maybeInnerTextSemantic._0,
                maybeInnerTextSemantic._1
              ], maybeInnerTextSemantic._2);
          var match$4 = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, isCanceled) {
                if (isCanceled.contents) {
                  throw {
                        RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                        Error: new Error()
                      };
                }
                return Curry._3(RunTime.getInnerTextForElement, context, addCancelCallback, element);
              });
          Curry._1(addCancelCallback, match$4[1]);
          return Curry._1(match$4[0], undefined).then(function (innerText) {
                      var tmp;
                      if (typeof innerText === "number") {
                        tmp = innerText === /* Ignored */0 ? true : false;
                      } else if (innerText.TAG === /* FullInnerText */0) {
                        var fullText = innerText._0;
                        tmp = Belt_Array.some(possibleMatchingSubstrings, (function (substring) {
                                return fullText.includes(substring);
                              }));
                      } else {
                        var prefix = innerText._0;
                        tmp = Belt_Array.some(possibleMatchingSubstrings, (function (substring) {
                                if (prefix.length > substring.length) {
                                  return prefix.includes(substring);
                                } else {
                                  console.warn("Unhandled ContainsInnerTextEnum against TruncatedInnerText");
                                  return false;
                                }
                              }));
                      }
                      return Promise.resolve(tmp);
                    });
      case /* ContainsInnerTextAllStrings */4 :
          var allRequiredSubstrings = $$Array.append([
                maybeInnerTextSemantic._0,
                maybeInnerTextSemantic._1
              ], maybeInnerTextSemantic._2);
          var match$5 = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, isCanceled) {
                if (isCanceled.contents) {
                  throw {
                        RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                        Error: new Error()
                      };
                }
                return Curry._3(RunTime.getInnerTextForElement, context, addCancelCallback, element);
              });
          Curry._1(addCancelCallback, match$5[1]);
          return Curry._1(match$5[0], undefined).then(function (innerText) {
                      var tmp;
                      if (typeof innerText === "number") {
                        tmp = innerText === /* Ignored */0 ? true : false;
                      } else if (innerText.TAG === /* FullInnerText */0) {
                        var fullText = innerText._0;
                        tmp = Belt_Array.every(allRequiredSubstrings, (function (substring) {
                                return fullText.includes(substring);
                              }));
                      } else {
                        var prefix = innerText._0;
                        tmp = Belt_Array.every(allRequiredSubstrings, (function (substring) {
                                if (prefix.length > substring.length) {
                                  return prefix.includes(substring);
                                } else {
                                  console.warn("Unhandled ContainsInnerTextAllStrings against TruncatedInnerText");
                                  return false;
                                }
                              }));
                      }
                      return Promise.resolve(tmp);
                    });
      
    }
  };
  var arg = function (text, expectedText) {
    return text === expectedText;
  };
  var arg$1 = function (text, expectedPrefix, param) {
    return text.startsWith(expectedPrefix);
  };
  var arg$2 = function (prefix, length, expectedText) {
    if (expectedText.startsWith(prefix)) {
      return length === expectedText.length;
    } else {
      return false;
    }
  };
  var arg$3 = function (prefix, length, expectedPrefix, expectedOriginalLength) {
    if (length === expectedOriginalLength) {
      if (prefix.length >= expectedPrefix.length) {
        return prefix.startsWith(expectedPrefix);
      } else {
        return expectedPrefix.startsWith(prefix);
      }
    } else {
      return false;
    }
  };
  var doesElementMatchInnerTextExactly = function (param) {
    return function (param$1) {
      var func = function (param$2, param$3, param$4, param$5, param$6, param$7, param$8) {
        return doesElementMatchInnerText(param, param$1, param$2, param$3, param$4, param$5, param$6, param$7, param$8);
      };
      return function (param) {
        return Curry._5(func, param, arg, arg$1, arg$2, arg$3);
      };
    };
  };
  var arg$4 = function (text, expectedText) {
    return text.includes(expectedText);
  };
  var arg$5 = function (text, expectedPrefix, expectedOriginalLength) {
    if (text.includes(expectedPrefix)) {
      return text.length >= expectedOriginalLength;
    } else {
      return false;
    }
  };
  var arg$6 = function (prefix, length, expectedText) {
    if (prefix.includes(expectedText)) {
      return length >= expectedText.length;
    } else {
      return false;
    }
  };
  var arg$7 = function (prefix, length, expectedPrefix, expectedOriginalLength) {
    if (prefix.startsWith(expectedPrefix)) {
      return length >= expectedOriginalLength;
    } else {
      return false;
    }
  };
  var doesElementIncludeInnerText = function (param) {
    return function (param$1) {
      var func = function (param$2, param$3, param$4, param$5, param$6, param$7, param$8) {
        return doesElementMatchInnerText(param, param$1, param$2, param$3, param$4, param$5, param$6, param$7, param$8);
      };
      return function (param) {
        return Curry._5(func, param, arg$4, arg$5, arg$6, arg$7);
      };
    };
  };
  var keepElementsThatMatchInnerTextExactly = function (useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, elements) {
    return Promise.all($$Array.mapi((function (index, element) {
                        return Curry._3(doesElementMatchInnerTextExactly(useInnerTextExactMatch)(maybeInnerTextSemantic), context, addCancelCallback, element).then(function (doesMatch) {
                                    return Promise.resolve([
                                                doesMatch,
                                                Caml_array.get(elements, index)
                                              ]);
                                  });
                      }), elements)).then(function (pairsOfDoesMatchAndElement) {
                return Promise.resolve(Belt_Array.map(Belt_Array.keep(pairsOfDoesMatchAndElement, (function (param) {
                                      return param[0];
                                    })), (function (prim) {
                                  return prim[1];
                                })));
              });
  };
  var onlyKeepVisibleElements = function (context, addCancelCallback, elements) {
    return ArrayUtils$SmartcutsMacros.keepAsync((function (element) {
                  return PromiseUtils$SmartcutsMacros.makePromiseCancelableBySurroundingPromise(addCancelCallback, (function (param) {
                                return Curry._2(RunTime.isVisibleOnPage, context, element);
                              }));
                }), elements);
  };
  var checkIsOptionElement = function (context, element) {
    return Curry._2(RunTime.getTagName, context, element).then(function (maybeTagName) {
                return Promise.resolve(Caml_obj.caml_equal(maybeTagName, "OPTION"));
              });
  };
  var onlyKeepVisibleElementsOrOptionElements = function (context, addCancelCallback, elements) {
    return ArrayUtils$SmartcutsMacros.keepAsync((function (element) {
                  return PromiseUtils$SmartcutsMacros.makePromiseCancelableBySurroundingPromise(addCancelCallback, (function (param) {
                                return checkIsOptionElement(context, element).then(function (isOptionElement) {
                                            if (isOptionElement) {
                                              return Promise.resolve(true);
                                            } else {
                                              return Curry._2(RunTime.isVisibleOnPage, context, element);
                                            }
                                          });
                              }));
                }), elements);
  };
  var isElementScrollable = function (context, element) {
    return PromiseUtils$SmartcutsMacros.resolveWith((function (param) {
                  var hasScrollableContent = param[0] > param[1];
                  var isOverflowHidden = param[2].includes("hidden");
                  if (hasScrollableContent) {
                    return !isOverflowHidden;
                  } else {
                    return false;
                  }
                }), Promise.all([
                    Curry._2(RunTime.getScrollHeight, context, element),
                    Curry._2(RunTime.getClientHeight, context, element),
                    Curry._2(RunTime.getOverflowYForElement, context, element)
                  ]));
  };
  var getElementsWithSameDepthAndAttributeKeysAsSelector = function (queryRoot, context, useInnerText, maybeInnerTextSemantic, attributesExistencePredicate, leafSelectorNode, addCancelCallback, domTree, selector, includeElementsNotVisible, param) {
    var attributesFilter;
    if (typeof attributesExistencePredicate === "number") {
      switch (attributesExistencePredicate) {
        case /* AllAttributes */0 :
            attributesFilter = (function (_selectorNodeIndex, _attrName) {
                return true;
              });
            break;
        case /* AttributesNotDataOrAria */1 :
            attributesFilter = (function (_selectorNodeIndex, attrName) {
                return !(attrName.startsWith("data-") || attrName.startsWith("aria-"));
              });
            break;
        case /* OnlyUseId */2 :
            attributesFilter = (function (_selectorNodeIndex, attrName) {
                return attrName === "id";
              });
            break;
        
      }
    } else {
      var nLevels = attributesExistencePredicate._0;
      attributesFilter = (function (selectorNodeIndex, attrName) {
          if (attrName === "class") {
            return (List.length(selector) - selectorNodeIndex | 0) > nLevels;
          } else {
            return !(attrName.startsWith("data-") || attrName.startsWith("aria-"));
          }
        });
    }
    return Curry._1(RunTime.getCurrentUrl, context).then(function (currentUrl) {
                  var cssSelector = Selector$SmartcutsMacros.toCssSelectorUsingTagChainAndAttributeExistence(queryRoot !== /* Document */0, attributesFilter, currentUrl, selector);
                  var tagName = leafSelectorNode.tagName;
                  return Curry._5(RunTime.querySelectorAll, context, queryRoot, domTree, tagName !== undefined && $$String.lowercase_ascii(tagName) === "option" ? true : includeElementsNotVisible, cssSelector);
                }).then(function (result_matches) {
                if (result_matches.TAG !== /* Ok */0) {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: result_matches._0
                            });
                }
                var matches = result_matches._0;
                var tmp;
                if (useInnerText) {
                  var param = leafSelectorNode.innerText;
                  var func = function (param$1, param$2, param$3, param$4) {
                    return keepElementsThatMatchInnerTextExactly(param, param$1, param$2, param$3, param$4);
                  };
                  tmp = Curry._2((function (param) {
                            var func$1 = Curry._1(func, param);
                            return function (param) {
                              var func$2 = Curry._1(func$1, param);
                              return function (param) {
                                return Curry._2(func$2, param, matches);
                              };
                            };
                          })(maybeInnerTextSemantic), context, addCancelCallback);
                } else {
                  tmp = Promise.resolve(matches);
                }
                return tmp.then(function (elements) {
                            if (includeElementsNotVisible) {
                              return Promise.resolve({
                                          TAG: /* Ok */0,
                                          _0: elements
                                        });
                            } else {
                              return onlyKeepVisibleElementsOrOptionElements(context, addCancelCallback, elements).then(function (matches) {
                                          return Promise.resolve({
                                                      TAG: /* Ok */0,
                                                      _0: matches
                                                    });
                                        });
                            }
                          });
              });
  };
  var calcDistanceBetweenBetweenIds = function (elementAttributes, selectorNode) {
    var match = Curry._1(RunTime.idFromAttributes, elementAttributes);
    var match$1 = selectorNode.id;
    if (match === undefined) {
      if (match$1 !== undefined) {
        return 1000;
      } else {
        return 0;
      }
    }
    if (match$1 === undefined) {
      return 10;
    }
    if (match === match$1) {
      return 0;
    }
    if (match.length === match$1.length) {
      return 10;
    }
    var _prefix = StringUtils$SmartcutsMacros.commonPrefix(match, match$1);
    if (_prefix !== undefined) {
      return 10;
    } else {
      return 1000;
    }
  };
  var calcDistanceBetweenBetweenClasses = function (elementAttributes, selectorNode) {
    var match = Curry._1(RunTime.classNamesFromAttributes, elementAttributes);
    var match$1 = selectorNode.classNames;
    var exit = 0;
    if (match.length !== 0) {
      exit = 2;
    } else {
      if (match$1.length === 0) {
        return 0;
      }
      if (match$1.length !== 0) {
        return 1000;
      }
      exit = 2;
    }
    if (exit === 2 && match$1.length === 0 && match.length !== 0) {
      return 1000;
    }
    var elementClassNamesSet = Belt_SetString.fromArray(match);
    var selectorClassNamesSet = Belt_SetString.fromArray(match$1);
    var commonClassNamesSet = Belt_SetString.intersect(elementClassNamesSet, selectorClassNamesSet);
    var elementClassNamesNotSharedBySelector = Belt_SetString.diff(elementClassNamesSet, selectorClassNamesSet);
    var selectorClassNamesNotSharedByElement = Belt_SetString.diff(selectorClassNamesSet, elementClassNamesSet);
    return (Math.imul(Belt_SetString.size(commonClassNamesSet), -10) + Math.imul(Belt_SetString.size(elementClassNamesNotSharedBySelector), 10) | 0) + Math.imul(Belt_SetString.size(selectorClassNamesNotSharedByElement), 10) | 0;
  };
  var calcDistanceBetweenAttributes = function (elementAttributes, selectorNode) {
    var elementAttributesThatAreNotIdOrClass = Curry._2(RunTime.keepAttributes, (function (attrName, _attrValue) {
            if (attrName !== "class" && attrName !== "id") {
              return !$$Array.mem(attrName, Selector$SmartcutsMacros.attributesToAvoidComparing);
            } else {
              return false;
            }
          }), elementAttributes);
    var selectorAttributes = Belt_Array.reduce(Selector$SmartcutsMacros.attributesToAvoidComparing, Belt_MapString.fromArray(selectorNode.attributes), Belt_MapString.remove);
    var match = Belt_MapString.size(elementAttributesThatAreNotIdOrClass);
    var match$1 = Belt_MapString.size(selectorAttributes);
    var exit = 0;
    if (match !== 0) {
      exit = 2;
    } else {
      if (match$1 === 0) {
        return 0;
      }
      if (match$1 > 0) {
        return 0;
      }
      exit = 2;
    }
    if (exit === 2 && match$1 === 0 && match > 0) {
      return 0;
    }
    var elementAttributeNames = Belt_SetString.fromArray(Belt_MapString.keysToArray(elementAttributesThatAreNotIdOrClass));
    var selectorAttributeNames = Belt_SetString.fromArray(Belt_MapString.keysToArray(selectorAttributes));
    var commonAttributeNamesSet = Belt_SetString.intersect(elementAttributeNames, selectorAttributeNames);
    var elementAttributeNamesNotSharedBySelector = Belt_SetString.diff(elementAttributeNames, selectorAttributeNames);
    var selectorAttributeNamesNotSharedByElement = Belt_SetString.diff(selectorAttributeNames, elementAttributeNames);
    return (Belt_Array.reduce(Belt_SetString.toArray(commonAttributeNamesSet), 0, (function (commonAttrDistance, attrName) {
                    var elementAttrVal = Belt_MapString.getExn(elementAttributesThatAreNotIdOrClass, attrName);
                    var selectorAttrVal = Belt_MapString.getExn(selectorAttributes, attrName);
                    var attributeValueDistance = FastLevenshtein.get(elementAttrVal, selectorAttrVal);
                    var tmp = attrName === "aria-label" ? (
                        attributeValueDistance === 0 ? -1000 : (
                            attributeValueDistance === 0 ? -10 : attributeValueDistance
                          )
                      ) : (
                        attributeValueDistance === 0 ? -10 : attributeValueDistance
                      );
                    return commonAttrDistance + tmp | 0;
                  })) + Math.imul(Belt_SetString.size(elementAttributeNamesNotSharedBySelector), 10) | 0) + Math.imul(Belt_SetString.size(selectorAttributeNamesNotSharedByElement), 10) | 0;
  };
  var distanceIsScrollable = function (element, context, selectorNode) {
    return PromiseUtils$SmartcutsMacros.resolveWith((function (isElementScrollable) {
                  var match = selectorNode.isScrollable;
                  if (match !== undefined) {
                    if (match) {
                      if (isElementScrollable) {
                        return 1;
                      } else {
                        return 0;
                      }
                    } else if (isElementScrollable) {
                      return 0;
                    } else {
                      return 1;
                    }
                  } else if (isElementScrollable) {
                    return 0;
                  } else {
                    return 1;
                  }
                }), isElementScrollable(context, element));
  };
  var distanceBetweenSelectorNodeAndElement = function (domTree, selectorNode, context, element) {
    var attributes = Curry._2(RunTime.getElementAttributes, domTree, element);
    var distanceId = calcDistanceBetweenBetweenIds(attributes, selectorNode);
    var distanceClasses = calcDistanceBetweenBetweenClasses(attributes, selectorNode);
    var distanceAttributes = calcDistanceBetweenAttributes(attributes, selectorNode);
    return checkIsOptionElement(context, element).then(function (isOptionElement) {
                if (isOptionElement && Caml_obj.caml_equal(selectorNode.tagName, "option")) {
                  return Promise.resolve([
                              Math.imul(distanceId, 100),
                              Math.imul(distanceClasses, 10),
                              (distanceAttributes << 0)
                            ]);
                } else {
                  return PromiseUtils$SmartcutsMacros.resolveWith((function (distanceIsScrollable) {
                                return [
                                        Math.imul(distanceId, 100),
                                        Math.imul(distanceClasses, 10),
                                        (distanceAttributes << 0),
                                        Math.imul(distanceIsScrollable, 50)
                                      ];
                              }), distanceIsScrollable(element, context, selectorNode));
                }
              });
  };
  var calcForElementChain = function (domTree, selector, context, elementChain) {
    var depthDistance = Math.abs(List.length(selector) - elementChain.length | 0);
    if (depthDistance > 0) {
      return Promise.resolve(Math.pow(10, depthDistance + 2 | 0));
    } else {
      return PromiseUtils$SmartcutsMacros.resolveWith((function (distanceArray) {
                    Curry._2(Log$SmartcutsMacros.selector.warn2, "calcForElementChain", Belt_Array.zip(elementChain, distanceArray));
                    var sumBy = function (f, xs) {
                      return Belt_Array.reduce(xs, 0.0, (function (acc, x) {
                                    return Curry._1(f, x) + acc;
                                  }));
                    };
                    return sumBy((function (param) {
                                  return sumBy((function (x) {
                                                return x;
                                              }), param);
                                }), distanceArray);
                  }), Belt_List.reduceWithIndex(selector, Promise.resolve([]), (function (promise, selectorNode, index) {
                        return PromiseUtils$SmartcutsMacros.resolveWith((function (param) {
                                      return Belt_Array.concat(param[0], [param[1]]);
                                    }), Promise.all([
                                        promise,
                                        distanceBetweenSelectorNodeAndElement(domTree, selectorNode, context, Caml_array.get(elementChain, index))
                                      ]));
                      })));
    }
  };
  var findElementsMatchingTagNameChainAndAttributesExistence = function (queryRoot, context, useInnerText, maybeInnerTextSemantic, leafSelectorNode, addCancelCallback, domTree, selector, includeElementsNotVisible, param) {
    var attributesExistencePredicateFallbacks = [
      /* AllAttributes */0,
      /* AttributesNotDataOrAria */1,
      /* StardardAttributesExceptClassNameAtLastNLevels */{
        _0: 3
      },
      /* OnlyUseId */2
    ];
    return PromiseUtils$SmartcutsMacros.map(ArrayUtils$SmartcutsMacros.shortcutAsync((function (attributesExistencePredicate) {
                      return PromiseUtils$SmartcutsMacros.map(getElementsWithSameDepthAndAttributeKeysAsSelector(queryRoot, context, useInnerText, maybeInnerTextSemantic, attributesExistencePredicate, leafSelectorNode, addCancelCallback, domTree, selector, includeElementsNotVisible, undefined), (function (result_matchingElements) {
                                    if (result_matchingElements.TAG !== /* Ok */0) {
                                      return {
                                              TAG: /* Error */1,
                                              _0: result_matchingElements._0
                                            };
                                    }
                                    var matchingElements = result_matchingElements._0;
                                    var match = matchingElements.length;
                                    if (match !== 0) {
                                      return {
                                              TAG: /* Ok */0,
                                              _0: matchingElements
                                            };
                                    }
                                    
                                  }));
                    }), attributesExistencePredicateFallbacks), (function (maybe_result_matchingElements) {
                  if (maybe_result_matchingElements !== undefined) {
                    if (maybe_result_matchingElements.TAG === /* Ok */0) {
                      return {
                              TAG: /* Ok */0,
                              _0: maybe_result_matchingElements._0
                            };
                    } else {
                      return {
                              TAG: /* Error */1,
                              _0: maybe_result_matchingElements._0
                            };
                    }
                  } else {
                    return {
                            TAG: /* Ok */0,
                            _0: []
                          };
                  }
                }));
  };
  var init = function (useInnerText, maybeInnerTextSemantic, queryRootOpt, context, addCancelCallback, maybeDomTree, maybeOnlyConsiderElementChainIf, includeElementsNotVisible, selector) {
    var queryRoot = queryRootOpt !== undefined ? queryRootOpt : /* Document */0;
    var arg = ListUtils$SmartcutsMacros.getLast(selector);
    var leafSelectorNode = (function (param) {
          return OptionUtils$SmartcutsMacros.getExn(param, arg);
        })("Expect to get leaf selector node");
    var selectorLength = List.length(selector);
    return findElementsMatchingTagNameChainAndAttributesExistence(queryRoot, context, useInnerText, maybeInnerTextSemantic, leafSelectorNode, addCancelCallback, maybeDomTree, selector, includeElementsNotVisible, undefined).then(function (result_matchingElements) {
                if (result_matchingElements.TAG !== /* Ok */0) {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: result_matchingElements._0
                            });
                }
                var matchingElements = result_matchingElements._0;
                return PromiseUtils$SmartcutsMacros.map(maybeDomTree !== undefined ? Promise.resolve(Caml_option.valFromOption(maybeDomTree)) : PromiseUtils$SmartcutsMacros.map(Curry._2(RunTime.fetchDomTree, context, addCancelCallback), (function (param) {
                                    return OptionUtils$SmartcutsMacros.getExn("Expect Some(domTree) when getting candidate branches", param);
                                  })), (function (domTree) {
                              var updatedMatchingElements = Belt_Array.map(matchingElements, Curry._1(RunTime.getUpdatedElementFromDomTree, domTree));
                              var arg = Belt_Array.map(updatedMatchingElements, (function (element) {
                                      var fullChain = Curry._2(RunTime.getParentChain, domTree, element);
                                      if (typeof queryRoot === "number") {
                                        return fullChain;
                                      } else {
                                        var element$1 = queryRoot._0;
                                        var index = Belt_Array.getIndexBy(fullChain, (function (currElement) {
                                                return Caml_obj.caml_equal(currElement, element$1);
                                              }));
                                        if (index !== undefined) {
                                          return Belt_Array.sliceToEnd(fullChain, index + 1 | 0);
                                        } else {
                                          return fullChain;
                                        }
                                      }
                                    }));
                              return {
                                      TAG: /* Ok */0,
                                      _0: [
                                        Belt_Array.keep(Belt_Array.keep((function (param) {
                                                        return function (param$1) {
                                                          return Util$SmartcutsMacros.spyTransform(param, param$1, arg);
                                                        };
                                                      })("before chain length filter")(function (x) {
                                                      return x;
                                                    }), (function (elementChain) {
                                                    return elementChain.length === selectorLength;
                                                  })), (function (elementChain) {
                                                if (maybeOnlyConsiderElementChainIf !== undefined) {
                                                  return Curry._1(maybeOnlyConsiderElementChainIf, elementChain);
                                                } else {
                                                  return true;
                                                }
                                              })),
                                        domTree
                                      ]
                                    };
                            }));
              });
  };
  var alwaysRequiredAttributeNames = [
    "autofocus",
    "role"
  ];
  var factorOutRequiredAttributesFromNode = function (node) {
    var attributesByRequiredOrNotRequired = ArrayUtils$SmartcutsMacros.groupBy((function (param) {
            if ($$Array.mem(param[0], alwaysRequiredAttributeNames)) {
              return "required";
            } else {
              return "not-required";
            }
          }), node.attributes);
    var requiredAttributes = OptionUtils$SmartcutsMacros.withDefault([], Belt_MapString.get(attributesByRequiredOrNotRequired, "required"));
    var optionalAttributes = OptionUtils$SmartcutsMacros.withDefault([], Belt_MapString.get(attributesByRequiredOrNotRequired, "not-required"));
    return [
            requiredAttributes,
            {
              id: node.id,
              tagName: node.tagName,
              classNames: node.classNames,
              attributes: optionalAttributes,
              index: node.index,
              innerText: node.innerText,
              isScrollable: node.isScrollable,
              attributeBlacklist: node.attributeBlacklist
            }
          ];
  };
  var getNextCombinationForNode = function (_searchStrategy, requiredAttributes, selectorNodeWithoutRequiredAttributes) {
    while(true) {
      var searchStrategy = _searchStrategy;
      if (typeof searchStrategy === "number") {
        switch (searchStrategy) {
          case /* ByTagAndId */0 :
              var arg = selectorNodeWithoutRequiredAttributes.tagName;
              return {
                      combo: {
                        id: selectorNodeWithoutRequiredAttributes.id,
                        tagName: selectorNodeWithoutRequiredAttributes.tagName,
                        classNames: [],
                        attributes: [],
                        index: undefined,
                        innerText: /* NoInnerText */1,
                        isScrollable: undefined,
                        attributeBlacklist: []
                      },
                      nextStrategy: {
                        TAG: /* ByTagAndClassNames */0,
                        _0: {
                          tagName: (function(arg){
                            return function (param) {
                              return OptionUtils$SmartcutsMacros.getExn(param, arg);
                            }
                            }(arg))("Expected tagName"),
                          classComboGenerator: ComboGenerator$SmartcutsMacros.make($$Array.to_list(selectorNodeWithoutRequiredAttributes.classNames))
                        }
                      }
                    };
          case /* ByIndex */1 :
              var index = selectorNodeWithoutRequiredAttributes.index;
              if (index !== undefined) {
                return {
                        combo: {
                          id: undefined,
                          tagName: selectorNodeWithoutRequiredAttributes.tagName,
                          classNames: [],
                          attributes: $$Array.append(requiredAttributes, ArrayUtils$SmartcutsMacros.filterMap((function (param) {
                                      var key = param[0];
                                      if (key === "contenteditable") {
                                        return [
                                                key,
                                                param[1]
                                              ];
                                      }
                                      
                                    }), selectorNodeWithoutRequiredAttributes.attributes)),
                          index: index,
                          innerText: /* NoInnerText */1,
                          isScrollable: undefined,
                          attributeBlacklist: []
                        },
                        nextStrategy: /* NoMoreStrategies */2
                      };
              } else {
                return ;
              }
          case /* NoMoreStrategies */2 :
              return ;
          
        }
      } else {
        if (searchStrategy.TAG === /* ByTagAndClassNames */0) {
          var match = searchStrategy._0;
          var tagName = match.tagName;
          var match$1 = ComboGenerator$SmartcutsMacros.generateNextCombo(match.classComboGenerator);
          if (match$1 !== undefined) {
            return {
                    combo: {
                      id: undefined,
                      tagName: tagName,
                      classNames: $$Array.of_list(match$1[0]),
                      attributes: requiredAttributes,
                      index: undefined,
                      innerText: /* NoInnerText */1,
                      isScrollable: undefined,
                      attributeBlacklist: []
                    },
                    nextStrategy: {
                      TAG: /* ByTagAndClassNames */0,
                      _0: {
                        tagName: tagName,
                        classComboGenerator: match$1[1]
                      }
                    }
                  };
          }
          _searchStrategy = {
            TAG: /* ByTagAndAttributes */1,
            _0: {
              tagName: tagName,
              attributeComboGenerator: ComboGenerator$SmartcutsMacros.make($$Array.to_list(selectorNodeWithoutRequiredAttributes.attributes))
            }
          };
          continue ;
        }
        var match$2 = searchStrategy._0;
        var tagName$1 = match$2.tagName;
        var match$3 = ComboGenerator$SmartcutsMacros.generateNextCombo(match$2.attributeComboGenerator);
        if (match$3 !== undefined) {
          return {
                  combo: {
                    id: undefined,
                    tagName: tagName$1,
                    classNames: [],
                    attributes: $$Array.append(requiredAttributes, $$Array.of_list(match$3[0])),
                    index: undefined,
                    innerText: /* NoInnerText */1,
                    isScrollable: undefined,
                    attributeBlacklist: []
                  },
                  nextStrategy: {
                    TAG: /* ByTagAndAttributes */1,
                    _0: {
                      tagName: tagName$1,
                      attributeComboGenerator: match$3[1]
                    }
                  }
                };
        }
        _searchStrategy = /* ByIndex */1;
        continue ;
      }
    };
  };
  var keepElementsThatIncludeInnerText = function (useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, elements) {
    return Promise.all($$Array.mapi((function (index, element) {
                        return Curry._3(doesElementIncludeInnerText(useInnerTextExactMatch)(maybeInnerTextSemantic), context, addCancelCallback, element).then(function (doesMatch) {
                                    return Promise.resolve([
                                                doesMatch,
                                                Caml_array.get(elements, index)
                                              ]);
                                  });
                      }), elements)).then(function (pairsOfDoesMatchAndElement) {
                return Promise.resolve(Belt_Array.map(Belt_Array.keep(pairsOfDoesMatchAndElement, (function (param) {
                                      return param[0];
                                    })), (function (prim) {
                                  return prim[1];
                                })));
              });
  };
  var withQuerySelectorAll = function (retriesOpt, context, queryRoot, $$default, cssSelector, withResults) {
    var retries = retriesOpt !== undefined ? retriesOpt : RunTime.maxRetries;
    return PromiseUtils$SmartcutsMacros.withRetries(retries, (function (addCancelCallback, param) {
                  return Curry._5(RunTime.querySelectorAll, context, queryRoot, undefined, cssSelector.includes("option") || cssSelector.includes("select") || cssSelector.includes("[type=\"file\"]"), cssSelector).then(function (result_results) {
                              if (result_results.TAG !== /* Ok */0) {
                                return Promise.resolve({
                                            TAG: /* Error */1,
                                            _0: result_results._0
                                          });
                              }
                              var results = result_results._0;
                              var match = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, param) {
                                    return Curry._2(withResults, addCancelCallback, results);
                                  });
                              Curry._1(addCancelCallback, match[1]);
                              return Curry._1(match[0], undefined);
                            });
                }), Curry._1(RunTime.shouldRetryForJsPromiseError, queryRoot), {
                TAG: /* Ok */0,
                _0: $$default
              }, undefined);
  };
  var maybeFindMatch = function (useInnerTextExactMatch, maybeInnerTextSemantic, searchStrategy, requiredAttributes, context, queryRoot, addCancelCallback, selectorNodeWithoutRequiredAttributes) {
    var match = getNextCombinationForNode(searchStrategy, requiredAttributes, selectorNodeWithoutRequiredAttributes);
    if (match === undefined) {
      return Promise.resolve({
                  TAG: /* Ok */0,
                  _0: /* NoMatch */0
                });
    }
    var nextStrategy = match.nextStrategy;
    var arg_0 = match.combo;
    var arg = {
      hd: arg_0,
      tl: /* [] */0
    };
    var cssSelector = (function (param) {
          return SelectorTree$SmartcutsMacros.stringify(param, arg);
        })(queryRoot !== /* Document */0);
    var maybeFindMatchByUsingNextStrategy = function (param, param$1) {
      return maybeFindMatch(useInnerTextExactMatch, maybeInnerTextSemantic, nextStrategy, requiredAttributes, context, queryRoot, param, param$1);
    };
    var match$1 = withQuerySelectorAll(undefined, context, queryRoot, /* NoMatch */0, cssSelector, (function (addCancelCallback, results) {
            return onlyKeepVisibleElementsOrOptionElements(context, addCancelCallback, results).then(function (results) {
                        var _twoOrMore = results.length;
                        if (_twoOrMore === 0) {
                          return maybeFindMatchByUsingNextStrategy(addCancelCallback, selectorNodeWithoutRequiredAttributes);
                        }
                        if (_twoOrMore !== 1) {
                          return keepElementsThatIncludeInnerText(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, results).then(function (elementsThatIncludeInnerText) {
                                      var _twoOrMore = elementsThatIncludeInnerText.length;
                                      if (_twoOrMore !== 0) {
                                        if (_twoOrMore !== 1) {
                                          return keepElementsThatMatchInnerTextExactly(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, elementsThatIncludeInnerText).then(function (elementsThatMatchInnerTextExactly) {
                                                      var _twoOrMore = elementsThatMatchInnerTextExactly.length;
                                                      if (_twoOrMore !== 0) {
                                                        if (_twoOrMore !== 1) {
                                                          return Promise.resolve(undefined).then(function (maybeMatch) {
                                                                      if (maybeMatch !== undefined) {
                                                                        return Promise.resolve({
                                                                                    TAG: /* Ok */0,
                                                                                    _0: /* ExactMatch */{
                                                                                      _0: {
                                                                                        element: Caml_option.valFromOption(maybeMatch),
                                                                                        fallbackStrategy: nextStrategy
                                                                                      }
                                                                                    }
                                                                                  });
                                                                      } else {
                                                                        return maybeFindMatchByUsingNextStrategy(addCancelCallback, selectorNodeWithoutRequiredAttributes);
                                                                      }
                                                                    });
                                                        } else {
                                                          return Promise.resolve({
                                                                      TAG: /* Ok */0,
                                                                      _0: /* ExactMatch */{
                                                                        _0: {
                                                                          element: Caml_array.get(elementsThatMatchInnerTextExactly, 0),
                                                                          fallbackStrategy: nextStrategy
                                                                        }
                                                                      }
                                                                    });
                                                        }
                                                      } else {
                                                        return maybeFindMatchByUsingNextStrategy(addCancelCallback, selectorNodeWithoutRequiredAttributes);
                                                      }
                                                    });
                                        } else {
                                          return Promise.resolve({
                                                      TAG: /* Ok */0,
                                                      _0: /* ExactMatch */{
                                                        _0: {
                                                          element: Caml_array.get(elementsThatIncludeInnerText, 0),
                                                          fallbackStrategy: nextStrategy
                                                        }
                                                      }
                                                    });
                                        }
                                      } else {
                                        return maybeFindMatchByUsingNextStrategy(addCancelCallback, selectorNodeWithoutRequiredAttributes);
                                      }
                                    });
                        }
                        var element = Caml_array.get(results, 0);
                        return Curry._3(doesElementMatchInnerTextExactly(useInnerTextExactMatch)(maybeInnerTextSemantic), context, addCancelCallback, element).then(function (doesMatch) {
                                    return Promise.resolve({
                                                TAG: /* Ok */0,
                                                _0: doesMatch ? /* ExactMatch */({
                                                      _0: {
                                                        element: element,
                                                        fallbackStrategy: nextStrategy
                                                      }
                                                    }) : /* NoMatch */0
                                              });
                                  });
                      });
          }));
    Curry._1(addCancelCallback, match$1[1]);
    return Curry._1(match$1[0], undefined);
  };
  var isHtmlAttributeUsefulInOptimization = function (key, param) {
    if (key.startsWith("aria-")) {
      return true;
    } else {
      key.startsWith("data-");
      return false;
    }
  };
  var isSelectorNodeOptimalToBecomeNewQueryRoot = function (context, queryRoot, isLeafNode, addCancelCallback, selectorNode) {
    var id = selectorNode.id;
    if (id !== undefined) {
      var selectorNodeWithOnlyId_id = id;
      var selectorNodeWithOnlyId_tagName = selectorNode.tagName;
      var selectorNodeWithOnlyId_classNames = [];
      var selectorNodeWithOnlyId_attributes = [];
      var selectorNodeWithOnlyId_attributeBlacklist = [];
      var selectorNodeWithOnlyId = {
        id: selectorNodeWithOnlyId_id,
        tagName: selectorNodeWithOnlyId_tagName,
        classNames: selectorNodeWithOnlyId_classNames,
        attributes: selectorNodeWithOnlyId_attributes,
        index: undefined,
        innerText: /* NoInnerText */1,
        isScrollable: undefined,
        attributeBlacklist: selectorNodeWithOnlyId_attributeBlacklist
      };
      var cssSelector = SelectorTree$SmartcutsMacros.stringify(queryRoot !== /* Document */0, {
            hd: selectorNodeWithOnlyId,
            tl: /* [] */0
          });
      var match = withQuerySelectorAll(undefined, context, queryRoot, [
            false,
            []
          ], cssSelector, (function (addCancelCallback, results) {
              return onlyKeepVisibleElements(context, addCancelCallback, results).then(function (elements) {
                          var isOptimal = 1 === elements.length;
                          if (isOptimal) {
                            return Promise.resolve({
                                        TAG: /* Ok */0,
                                        _0: [
                                          isOptimal,
                                          elements
                                        ]
                                      });
                          } else {
                            return isSelectorNodeOptimalToBecomeNewQueryRoot(context, queryRoot, isLeafNode, addCancelCallback, {
                                        id: undefined,
                                        tagName: selectorNode.tagName,
                                        classNames: selectorNode.classNames,
                                        attributes: selectorNode.attributes,
                                        index: selectorNode.index,
                                        innerText: selectorNode.innerText,
                                        isScrollable: selectorNode.isScrollable,
                                        attributeBlacklist: selectorNode.attributeBlacklist
                                      });
                          }
                        });
            }));
      Curry._1(addCancelCallback, match[1]);
      return Curry._1(match[0], undefined);
    }
    var tagName = selectorNode.tagName;
    return Util$SmartcutsMacros.Shortcut.promise((function (param) {
                    var value = param[1];
                    var key = param[0];
                    if (!isHtmlAttributeUsefulInOptimization(key, value)) {
                      return Promise.resolve(undefined);
                    }
                    var selectorNodeToTry_classNames = [];
                    var selectorNodeToTry_attributes = [[
                        key,
                        value
                      ]];
                    var selectorNodeToTry_attributeBlacklist = [];
                    var selectorNodeToTry = {
                      id: undefined,
                      tagName: tagName,
                      classNames: selectorNodeToTry_classNames,
                      attributes: selectorNodeToTry_attributes,
                      index: undefined,
                      innerText: /* NoInnerText */1,
                      isScrollable: undefined,
                      attributeBlacklist: selectorNodeToTry_attributeBlacklist
                    };
                    var cssSelector = SelectorTree$SmartcutsMacros.stringify(queryRoot !== /* Document */0, {
                          hd: selectorNodeToTry,
                          tl: /* [] */0
                        });
                    var match = withQuerySelectorAll(undefined, context, queryRoot, undefined, cssSelector, (function (addCancelCallback, results) {
                            return onlyKeepVisibleElements(context, addCancelCallback, results).then(function (elements) {
                                        var length = elements.length;
                                        if (length !== 0 && !(length !== 1 && !(length <= 2 && !isLeafNode))) {
                                          return Promise.resolve({
                                                      TAG: /* Ok */0,
                                                      _0: elements
                                                    });
                                        } else {
                                          return Promise.resolve({
                                                      TAG: /* Ok */0,
                                                      _0: undefined
                                                    });
                                        }
                                      });
                          }));
                    Curry._1(addCancelCallback, match[1]);
                    return PromiseUtils$SmartcutsMacros.map(Curry._1(match[0], undefined), (function (result_maybeElements) {
                                  if (result_maybeElements.TAG !== /* Ok */0) {
                                    return {
                                            TAG: /* Error */1,
                                            _0: result_maybeElements._0
                                          };
                                  }
                                  var elements = result_maybeElements._0;
                                  if (elements !== undefined) {
                                    return {
                                            TAG: /* Ok */0,
                                            _0: elements
                                          };
                                  }
                                  
                                }));
                  }), selectorNode.attributes).then(function (maybe_resultElements) {
                if (maybe_resultElements !== undefined) {
                  if (maybe_resultElements.TAG === /* Ok */0) {
                    return Promise.resolve({
                                TAG: /* Ok */0,
                                _0: [
                                  true,
                                  maybe_resultElements._0
                                ]
                              });
                  } else {
                    return Promise.resolve({
                                TAG: /* Error */1,
                                _0: maybe_resultElements._0
                              });
                  }
                } else {
                  return Promise.resolve({
                              TAG: /* Ok */0,
                              _0: [
                                false,
                                []
                              ]
                            });
                }
              });
  };
  var findNestedNodesToStartSearch = function (context, queryRoot, selector, addCancelCallback) {
    if (List.length(selector) === 1) {
      return Promise.resolve({
                  TAG: /* Ok */0,
                  _0: [
                    undefined,
                    selector
                  ]
                });
    } else {
      return Belt_List.reduceReverse(selector, Promise.resolve({
                      TAG: /* Ok */0,
                      _0: [
                        undefined,
                        /* [] */0
                      ]
                    }), (function (prevPromise, selectorNode) {
                    return prevPromise.then(function (prevResult) {
                                if (prevResult.TAG !== /* Ok */0) {
                                  return Promise.resolve({
                                              TAG: /* Error */1,
                                              _0: prevResult._0
                                            });
                                }
                                var match = prevResult._0;
                                if (match[0] !== undefined) {
                                  return Promise.resolve(prevResult);
                                }
                                var prevSelector = match[1];
                                return PromiseUtils$SmartcutsMacros.makePromiseCancelableBySurroundingPromise(addCancelCallback, (function (addCancelCallback) {
                                              return isSelectorNodeOptimalToBecomeNewQueryRoot(context, queryRoot, List.length(prevSelector) === 0, addCancelCallback, selectorNode).then(function (result_pair) {
                                                          if (result_pair.TAG !== /* Ok */0) {
                                                            return Promise.resolve({
                                                                        TAG: /* Error */1,
                                                                        _0: result_pair._0
                                                                      });
                                                          }
                                                          var match = result_pair._0;
                                                          if (match[0]) {
                                                            return Promise.resolve({
                                                                        TAG: /* Ok */0,
                                                                        _0: [
                                                                          match[1],
                                                                          prevSelector
                                                                        ]
                                                                      });
                                                          } else {
                                                            return Promise.resolve({
                                                                        TAG: /* Ok */0,
                                                                        _0: [
                                                                          undefined,
                                                                          {
                                                                            hd: selectorNode,
                                                                            tl: prevSelector
                                                                          }
                                                                        ]
                                                                      });
                                                          }
                                                        });
                                            }));
                              });
                  }));
    }
  };
  var startComboSearchForSelectorNode = function (useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, backtrace, stack, selectorNode, recursiveSearch, addCancelCallback, remainder) {
    var match = factorOutRequiredAttributesFromNode(selectorNode);
    var selectorNodeWithoutRequiredAttributes = match[1];
    var requiredAttributes = match[0];
    return maybeFindMatch(useInnerTextExactMatch, maybeInnerTextSemantic, /* ByTagAndId */0, requiredAttributes, context, queryRoot, addCancelCallback, selectorNodeWithoutRequiredAttributes).then(function (result_found) {
                if (result_found.TAG !== /* Ok */0) {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: result_found._0
                            });
                }
                var match = result_found._0;
                if (!match) {
                  return Curry._5(backtrace, useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, stack);
                }
                var match$1 = match._0;
                var nextQueryRoot_0 = match$1.element;
                var nextQueryRoot = {
                  TAG: /* Element */0,
                  _0: nextQueryRoot_0,
                  _1: undefined
                };
                return Curry._6(recursiveSearch, useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                            queryRoot: nextQueryRoot,
                            stack: {
                              hd: {
                                selectorNodeWithoutRequiredAttributes: selectorNodeWithoutRequiredAttributes,
                                requiredAttributes: requiredAttributes,
                                queryRoot: nextQueryRoot,
                                fallbackStrategy: match$1.fallbackStrategy,
                                selector: remainder
                              },
                              tl: stack
                            }
                          }, remainder);
              });
  };
  var recursiveSearch_ = function (useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, param, selector) {
    var stack = param.stack;
    var queryRoot = param.queryRoot;
    if (selector) {
      var remainder = selector.tl;
      var selectorNode = selector.hd;
      var cssSelector = SelectorTree$SmartcutsMacros.stringify(queryRoot !== /* Document */0, {
            hd: selectorNode,
            tl: /* [] */0
          });
      var match = withQuerySelectorAll(undefined, context, queryRoot, undefined, cssSelector, (function (addCancelCallback, results) {
              return onlyKeepVisibleElementsOrOptionElements(context, addCancelCallback, results).then(function (resultElements) {
                          var _twoOrMore = resultElements.length;
                          if (_twoOrMore === 0) {
                            return startComboSearchForSelectorNode(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, backtrace, stack, selectorNode, recursiveSearch, addCancelCallback, remainder);
                          }
                          if (_twoOrMore !== 1) {
                            return keepElementsThatIncludeInnerText(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, resultElements).then(function (elementsThatIncludeInnerText) {
                                        var _twoOrMore = elementsThatIncludeInnerText.length;
                                        if (_twoOrMore === 0) {
                                          return startComboSearchForSelectorNode(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, backtrace, stack, selectorNode, recursiveSearch, addCancelCallback, remainder);
                                        }
                                        if (_twoOrMore === 1) {
                                          return Promise.resolve({
                                                      TAG: /* Ok */0,
                                                      _0: Caml_option.some(Caml_array.get(elementsThatIncludeInnerText, 0))
                                                    });
                                        }
                                        var match = factorOutRequiredAttributesFromNode(selectorNode);
                                        var selectorNodeWithoutRequiredAttributes = match[1];
                                        var requiredAttributes = match[0];
                                        return Util$SmartcutsMacros.shortcutPromise((function (element) {
                                                        return PromiseUtils$SmartcutsMacros.map(recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                                                                        queryRoot: {
                                                                          TAG: /* Element */0,
                                                                          _0: element,
                                                                          _1: undefined
                                                                        },
                                                                        stack: {
                                                                          hd: {
                                                                            selectorNodeWithoutRequiredAttributes: selectorNodeWithoutRequiredAttributes,
                                                                            requiredAttributes: requiredAttributes,
                                                                            queryRoot: queryRoot,
                                                                            fallbackStrategy: /* ByTagAndId */0,
                                                                            selector: remainder
                                                                          },
                                                                          tl: stack
                                                                        }
                                                                      }, remainder), (function (result_maybeResult) {
                                                                      if (result_maybeResult.TAG !== /* Ok */0) {
                                                                        return {
                                                                                TAG: /* Error */1,
                                                                                _0: result_maybeResult._0
                                                                              };
                                                                      }
                                                                      var result_ = result_maybeResult._0;
                                                                      if (result_ !== undefined) {
                                                                        return {
                                                                                TAG: /* Ok */0,
                                                                                _0: Caml_option.valFromOption(result_)
                                                                              };
                                                                      }
                                                                      
                                                                    }));
                                                      }), elementsThatIncludeInnerText).then(function (maybe_result_Element) {
                                                    if (maybe_result_Element !== undefined) {
                                                      if (maybe_result_Element.TAG === /* Ok */0) {
                                                        return Promise.resolve({
                                                                    TAG: /* Ok */0,
                                                                    _0: Caml_option.some(maybe_result_Element._0)
                                                                  });
                                                      } else {
                                                        return Promise.resolve({
                                                                    TAG: /* Error */1,
                                                                    _0: maybe_result_Element._0
                                                                  });
                                                      }
                                                    } else {
                                                      return startComboSearchForSelectorNode(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, backtrace, stack, selectorNode, recursiveSearch, addCancelCallback, remainder);
                                                    }
                                                  });
                                      });
                          }
                          var match = factorOutRequiredAttributesFromNode(selectorNode);
                          return recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                                      queryRoot: {
                                        TAG: /* Element */0,
                                        _0: Caml_array.get(resultElements, 0),
                                        _1: undefined
                                      },
                                      stack: {
                                        hd: {
                                          selectorNodeWithoutRequiredAttributes: match[1],
                                          requiredAttributes: match[0],
                                          queryRoot: queryRoot,
                                          fallbackStrategy: /* ByTagAndId */0,
                                          selector: remainder
                                        },
                                        tl: stack
                                      }
                                    }, remainder);
                        });
            }));
      Curry._1(addCancelCallback, match[1]);
      return Curry._1(match[0], undefined);
    }
    if (typeof queryRoot === "number") {
      return Promise.resolve({
                  TAG: /* Ok */0,
                  _0: undefined
                });
    }
    var element = queryRoot._0;
    if (useInnerTextExactMatch === undefined) {
      return Promise.resolve({
                  TAG: /* Ok */0,
                  _0: Caml_option.some(element)
                });
    }
    var arg = Caml_option.some(element);
    return PromiseUtils$SmartcutsMacros.map((function (param) {
                    return OptionUtils$SmartcutsMacros.keepAsync(param, arg);
                  })(function (param) {
                    return doesElementMatchInnerText(useInnerTextExactMatch, maybeInnerTextSemantic, context, (function (text, expectedText) {
                                  return text === expectedText;
                                }), (function (text, expectedPrefix, param) {
                                  return text.startsWith(expectedPrefix);
                                }), (function (prefix, param, expectedText) {
                                  return expectedText.startsWith(prefix);
                                }), (function (prefix, param, expectedPrefix, param$1) {
                                  return prefix.startsWith(expectedPrefix);
                                }), addCancelCallback, param);
                  }), (function (maybeElement) {
                  return {
                          TAG: /* Ok */0,
                          _0: maybeElement
                        };
                }));
  };
  var recursiveSearch = function (useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, state, selectorAndSearchScope) {
    return PromiseUtils$SmartcutsMacros.withTimeout(0, recursiveSearch_(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, state, selectorAndSearchScope));
  };
  var backtrace = function (useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, stack) {
    if (!stack) {
      return Promise.resolve({
                  TAG: /* Ok */0,
                  _0: undefined
                });
    }
    var prevBreakpoints = stack.tl;
    var lastBreakpoint = stack.hd;
    var selector = lastBreakpoint.selector;
    return maybeFindMatch(useInnerTextExactMatch, maybeInnerTextSemantic, lastBreakpoint.fallbackStrategy, lastBreakpoint.requiredAttributes, context, lastBreakpoint.queryRoot, addCancelCallback, lastBreakpoint.selectorNodeWithoutRequiredAttributes).then(function (result_results) {
                if (result_results.TAG !== /* Ok */0) {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: result_results._0
                            });
                }
                var match = result_results._0;
                if (!match) {
                  return backtrace(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, prevBreakpoints);
                }
                var match$1 = match._0;
                return recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                            queryRoot: {
                              TAG: /* Element */0,
                              _0: match$1.element,
                              _1: undefined
                            },
                            stack: {
                              hd: {
                                selectorNodeWithoutRequiredAttributes: lastBreakpoint.selectorNodeWithoutRequiredAttributes,
                                requiredAttributes: lastBreakpoint.requiredAttributes,
                                queryRoot: lastBreakpoint.queryRoot,
                                fallbackStrategy: match$1.fallbackStrategy,
                                selector: lastBreakpoint.selector
                              },
                              tl: prevBreakpoints
                            }
                          }, selector);
              });
  };
  var attemptToFindDeepestNode = function (useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, addCancelCallback, selector) {
    Curry._1(Log$SmartcutsMacros.selector.log1, "Searching via deepest node");
    var maybePromisedResult = OptionUtils$SmartcutsMacros.map(Belt_List.get(List.rev(selector), 0), (function (deepestNode) {
            return recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                        queryRoot: queryRoot,
                        stack: /* [] */0
                      }, {
                        hd: deepestNode,
                        tl: /* [] */0
                      });
          }));
    return OptionUtils$SmartcutsMacros.withDefault(Promise.resolve({
                    TAG: /* Ok */0,
                    _0: undefined
                  }), maybePromisedResult);
  };
  var topDownSearch = function (useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, selector, addCancelCallback) {
    var match = PromiseUtils$SmartcutsMacros.withRetries(3, (function (addCancelCallback, param) {
            Curry._1(Log$SmartcutsMacros.selector.log1, "Searching via deepest node");
            return findNestedNodesToStartSearch(context, queryRoot, selector, addCancelCallback).then(function (result) {
                        if (result.TAG !== /* Ok */0) {
                          return Promise.resolve({
                                      TAG: /* Error */1,
                                      _0: result._0
                                    });
                        }
                        var match = result._0;
                        var selector = match[1];
                        var maybeOptimalStartElements = match[0];
                        Curry._1(Log$SmartcutsMacros.selector.log1, "Searching via deepest node - nested nodes");
                        Curry._3(Log$SmartcutsMacros.selector.log3, "results", maybeOptimalStartElements, $$Array.of_list(selector));
                        if (maybeOptimalStartElements === undefined) {
                          return recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                                      queryRoot: queryRoot,
                                      stack: /* [] */0
                                    }, selector);
                        }
                        if (!selector && maybeOptimalStartElements.length === 1) {
                          return recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                                      queryRoot: {
                                        TAG: /* Element */0,
                                        _0: Caml_array.get(maybeOptimalStartElements, 0),
                                        _1: undefined
                                      },
                                      stack: /* [] */0
                                    }, selector);
                        }
                        return Util$SmartcutsMacros.Shortcut.promise((function (element) {
                                        return PromiseUtils$SmartcutsMacros.map(recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                                                        queryRoot: {
                                                          TAG: /* Element */0,
                                                          _0: element,
                                                          _1: undefined
                                                        },
                                                        stack: /* [] */0
                                                      }, selector), (function (result_maybeElement) {
                                                      if (result_maybeElement.TAG !== /* Ok */0) {
                                                        return {
                                                                TAG: /* Error */1,
                                                                _0: result_maybeElement._0
                                                              };
                                                      }
                                                      var element = result_maybeElement._0;
                                                      if (element !== undefined) {
                                                        return {
                                                                TAG: /* Ok */0,
                                                                _0: Caml_option.valFromOption(element)
                                                              };
                                                      }
                                                      
                                                    }));
                                      }), maybeOptimalStartElements).then(function (maybe_result_element) {
                                    if (maybe_result_element !== undefined) {
                                      if (maybe_result_element.TAG === /* Ok */0) {
                                        return Promise.resolve({
                                                    TAG: /* Ok */0,
                                                    _0: Caml_option.some(maybe_result_element._0)
                                                  });
                                      } else {
                                        return Promise.resolve({
                                                    TAG: /* Error */1,
                                                    _0: maybe_result_element._0
                                                  });
                                      }
                                    } else {
                                      return recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                                                  queryRoot: queryRoot,
                                                  stack: /* [] */0
                                                }, selector);
                                    }
                                  });
                      });
          }), Curry._1(RunTime.shouldRetryForJsPromiseError, queryRoot), {
          TAG: /* Ok */0,
          _0: undefined
        }, undefined);
    Curry._1(addCancelCallback, match[1]);
    return Curry._1(match[0], undefined);
  };
  var shouldOnlySearchViaInnerText = function (selector) {
    var match = SelectorTree$SmartcutsMacros.maybeGetLeafNode(selector);
    if (match !== undefined && typeof match.innerText !== "number") {
      return true;
    } else {
      return false;
    }
  };
  var scrollVerticallyToLoadAllElements = function (context, scrollableElement) {
    var loop = function (clientHeight, lastScrollHeight) {
      return Curry._2(RunTime.getScrollHeight, context, scrollableElement).then(function (scrollHeight) {
                  if (scrollHeight <= lastScrollHeight) {
                    return Util$SmartcutsMacros.wait(120).then(function (param) {
                                return Curry._2(RunTime.getScrollHeight, context, scrollableElement).then(function (scrollHeight_2) {
                                            if (scrollHeight_2 <= lastScrollHeight) {
                                              return Promise.resolve(undefined);
                                            }
                                            var func = Curry._1(RunTime.scrollTo, context);
                                            var arg = scrollHeight_2 - clientHeight | 0;
                                            return Curry._3(func, undefined, arg, scrollableElement).then(function (param) {
                                                        return loop(clientHeight, scrollHeight_2);
                                                      });
                                          });
                              });
                  }
                  var func = Curry._1(RunTime.scrollTo, context);
                  var arg = scrollHeight - clientHeight | 0;
                  return Curry._3(func, undefined, arg, scrollableElement).then(function (param) {
                              return loop(clientHeight, scrollHeight);
                            });
                });
    };
    return Promise.all([
                  Curry._2(RunTime.getScrollHeight, context, scrollableElement),
                  Curry._2(RunTime.getClientHeight, context, scrollableElement)
                ]).then(function (param) {
                var clientHeight = param[1];
                var scrollHeight = param[0];
                var func = Curry._1(RunTime.scrollTo, context);
                var arg = scrollHeight - clientHeight | 0;
                return Curry._3(func, undefined, arg, scrollableElement).then(function (param) {
                            return loop(clientHeight, scrollHeight);
                          });
              });
  };
  var findChainWithLowestScoreAndAnyTiedChains = function (chainDistancePairs) {
    return ArrayUtils$SmartcutsMacros.splitAtFirstExn("Expect to get Some(chainWithLowestScore)", ArrayUtils$SmartcutsMacros.filterMap((function (param) {
                      var distance = param[1];
                      if (Belt_Array.every(chainDistancePairs, (function (param) {
                                return param[1] >= distance;
                              }))) {
                        return param[0];
                      }
                      
                    }), chainDistancePairs));
  };
  var search1 = function (useInnerText, maybeInnerTextSemantic, context, queryRoot, fullSelector, addOnPredicateTimedOutCallback, maybeDomTree, maybeOnlyConsiderElementChainIf, includeElementsNotVisible, param) {
    var selectorSlices = Selector$SmartcutsMacros.splitForShadowDom(fullSelector);
    return Belt_Array.reduceWithIndex(selectorSlices, Promise.resolve({
                      TAG: /* Ok */0,
                      _0: [
                        maybeDomTree,
                        queryRoot
                      ]
                    }), (function (lastProm, selectorSlice, selectorSliceIndex) {
                    return lastProm.then(function (result_pair) {
                                if (result_pair.TAG !== /* Ok */0) {
                                  return Promise.resolve({
                                              TAG: /* Error */1,
                                              _0: result_pair._0
                                            });
                                }
                                var match = result_pair._0;
                                var maybeQueryRoot = match[1];
                                var maybeDomTree = match[0];
                                if (maybeQueryRoot === undefined) {
                                  return Promise.resolve({
                                              TAG: /* Ok */0,
                                              _0: [
                                                maybeDomTree,
                                                maybeQueryRoot
                                              ]
                                            });
                                }
                                var match$1 = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, param) {
                                      var isLastSlice = selectorSliceIndex === (selectorSlices.length - 1 | 0);
                                      return init(useInnerText && isLastSlice, maybeInnerTextSemantic, maybeQueryRoot, context, addCancelCallback, maybeDomTree, maybeOnlyConsiderElementChainIf, includeElementsNotVisible, selectorSlice).then(function (result_chainsAndTree) {
                                                  if (result_chainsAndTree.TAG !== /* Ok */0) {
                                                    return Promise.resolve({
                                                                TAG: /* Error */1,
                                                                _0: result_chainsAndTree._0
                                                              });
                                                  }
                                                  var match = result_chainsAndTree._0;
                                                  var domTree = match[1];
                                                  var elementChains = match[0];
                                                  if (elementChains.length === 0) {
                                                    return Promise.resolve({
                                                                TAG: /* Ok */0,
                                                                _0: [
                                                                  Caml_option.some(domTree),
                                                                  undefined
                                                                ]
                                                              });
                                                  }
                                                  var func = function (param, param$1, param$2) {
                                                    return Promise.all(Belt_Array.map(param$2, (function (elementChain) {
                                                                      return PromiseUtils$SmartcutsMacros.resolveWith((function (distance) {
                                                                                    return [
                                                                                            elementChain,
                                                                                            distance
                                                                                          ];
                                                                                  }), calcForElementChain(domTree, param, param$1, elementChain));
                                                                    })));
                                                  };
                                                  var func$1 = Curry._1(func, selectorSlice);
                                                  return Curry._1((function (param) {
                                                                  return Curry._2(func$1, param, elementChains);
                                                                }), context).then(function (chainDistancePairs) {
                                                              var func = function (param, param$1) {
                                                                var match = findChainWithLowestScoreAndAnyTiedChains(param$1);
                                                                var chainWithLowestScore = match[0];
                                                                var tiedChains = match[1];
                                                                return Belt_Array.reduce(tiedChains, chainWithLowestScore, (function (currBestChain, currChain) {
                                                                              var maybeNextBestChain = ListUtils$SmartcutsMacros.shortcutWithIndex((function (selectorNode, nodeIndex) {
                                                                                      var maybeRecordedSiblingIndex = selectorNode.index;
                                                                                      var currElementA = Caml_array.get(currBestChain, nodeIndex);
                                                                                      var currElementB = Caml_array.get(currChain, nodeIndex);
                                                                                      var siblingIndexA = Curry._2(RunTime.getSiblingIndex, param, currElementA);
                                                                                      var siblingIndexB = Curry._2(RunTime.getSiblingIndex, param, currElementB);
                                                                                      if (maybeRecordedSiblingIndex !== undefined && !(maybeRecordedSiblingIndex === siblingIndexA && maybeRecordedSiblingIndex === siblingIndexB)) {
                                                                                        if (maybeRecordedSiblingIndex === siblingIndexA) {
                                                                                          return currBestChain;
                                                                                        } else if (maybeRecordedSiblingIndex === siblingIndexB) {
                                                                                          return currChain;
                                                                                        } else {
                                                                                          return ;
                                                                                        }
                                                                                      }
                                                                                      
                                                                                    }), selectorSlice);
                                                                              return OptionUtils$SmartcutsMacros.withDefault(currBestChain, maybeNextBestChain);
                                                                            }));
                                                              };
                                                              var bestChain = Curry._2(func, domTree, chainDistancePairs);
                                                              var maybeNextQueryRoot = OptionUtils$SmartcutsMacros.map(ArrayUtils$SmartcutsMacros.last(bestChain), (function (bestElement) {
                                                                      if (isLastSlice) {
                                                                        var tmp;
                                                                        if (typeof maybeQueryRoot === "number") {
                                                                          tmp = bestChain.length;
                                                                        } else if (maybeQueryRoot.TAG === /* Element */0) {
                                                                          var depth = maybeQueryRoot._1;
                                                                          tmp = depth !== undefined ? depth + bestChain.length | 0 : bestChain.length;
                                                                        } else {
                                                                          tmp = maybeQueryRoot._1 + bestChain.length | 0;
                                                                        }
                                                                        return {
                                                                                TAG: /* Element */0,
                                                                                _0: bestElement,
                                                                                _1: tmp
                                                                              };
                                                                      }
                                                                      var arg = Curry._2(RunTime.getDomShadowRoot, domTree, bestElement);
                                                                      var tmp$1;
                                                                      if (typeof maybeQueryRoot === "number") {
                                                                        tmp$1 = bestChain.length + 1 | 0;
                                                                      } else if (maybeQueryRoot.TAG === /* Element */0) {
                                                                        var depth$1 = maybeQueryRoot._1;
                                                                        tmp$1 = depth$1 !== undefined ? (depth$1 + bestChain.length | 0) + 1 | 0 : bestChain.length + 1 | 0;
                                                                      } else {
                                                                        tmp$1 = (maybeQueryRoot._1 + bestChain.length | 0) + 1 | 0;
                                                                      }
                                                                      return {
                                                                              TAG: /* ShadowRoot */1,
                                                                              _0: (function (param) {
                                                                                    return OptionUtils$SmartcutsMacros.getExn(param, arg);
                                                                                  })("Expected dom shadow root"),
                                                                              _1: tmp$1
                                                                            };
                                                                    }));
                                                              return Promise.resolve({
                                                                          TAG: /* Ok */0,
                                                                          _0: [
                                                                            Caml_option.some(domTree),
                                                                            maybeNextQueryRoot
                                                                          ]
                                                                        });
                                                            });
                                                });
                                    });
                                Curry._1(addOnPredicateTimedOutCallback, match$1[1]);
                                return Curry._1(match$1[0], undefined);
                              });
                  })).then(function (result) {
                if (result.TAG !== /* Ok */0) {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: result._0
                            });
                }
                var maybeQueryRoot = result._0[1];
                if (maybeQueryRoot !== undefined && typeof maybeQueryRoot !== "number") {
                  return Promise.resolve({
                              TAG: /* Ok */0,
                              _0: Caml_option.some(maybeQueryRoot._0)
                            });
                } else {
                  return Promise.resolve({
                              TAG: /* Ok */0,
                              _0: undefined
                            });
                }
              });
  };
  var searchWithScrolling = function (useInnerText, maybeInnerTextSemantic, context, queryRoot, selector, addOnPredicateTimedOutCallback, domTree, onlyConsiderElementChainIf, includeElementsNotVisible, param) {
    return search1(useInnerText, maybeInnerTextSemantic, context, queryRoot, selector, addOnPredicateTimedOutCallback, domTree, onlyConsiderElementChainIf, includeElementsNotVisible, undefined).then(function (result) {
                if (result.TAG !== /* Ok */0) {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: result._0
                            });
                }
                if (result._0 !== undefined) {
                  return Promise.resolve(result);
                }
                if (!useInnerText) {
                  return Promise.resolve({
                              TAG: /* Ok */0,
                              _0: undefined
                            });
                }
                var selectorDepth = Belt_List.length(selector);
                return Belt_List.reduceWithIndex(Belt_List.reverse(selector), Promise.resolve({
                                TAG: /* Ok */0,
                                _0: undefined
                              }), (function (promise, selectorNode, index) {
                              return promise.then(function (result_maybeResult) {
                                          if (result_maybeResult.TAG !== /* Ok */0) {
                                            return Promise.resolve({
                                                        TAG: /* Error */1,
                                                        _0: result_maybeResult._0
                                                      });
                                          }
                                          var element = result_maybeResult._0;
                                          if (element !== undefined) {
                                            return Promise.resolve({
                                                        TAG: /* Ok */0,
                                                        _0: Caml_option.some(Caml_option.valFromOption(element))
                                                      });
                                          }
                                          if (selectorNode.isScrollable === undefined || Caml_obj.caml_equal(selectorNode.isScrollable, false)) {
                                            return Promise.resolve({
                                                        TAG: /* Ok */0,
                                                        _0: undefined
                                                      });
                                          }
                                          var indexOfLastScrollableElement = selectorDepth - index | 0;
                                          var arg = Belt_List.take(selector, indexOfLastScrollableElement);
                                          var selectorToScrollableElement = (function (param) {
                                                return OptionUtils$SmartcutsMacros.getExn(param, arg);
                                              })("Expect to get selectorToScrollableElement");
                                          var arg$1 = Belt_List.drop(selector, indexOfLastScrollableElement);
                                          var selectorFromScrollableElement = (function (param) {
                                                return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                                              })("Expect to get selectorFromScrollableElement");
                                          return search1(useInnerText, maybeInnerTextSemantic, context, queryRoot, selectorToScrollableElement, addOnPredicateTimedOutCallback, domTree, onlyConsiderElementChainIf, includeElementsNotVisible, undefined).then(function (result_maybeElement) {
                                                      if (result_maybeElement.TAG !== /* Ok */0) {
                                                        return Promise.resolve({
                                                                    TAG: /* Error */1,
                                                                    _0: result_maybeElement._0
                                                                  });
                                                      }
                                                      var scrollableElement = result_maybeElement._0;
                                                      if (scrollableElement === undefined) {
                                                        return Promise.resolve({
                                                                    TAG: /* Ok */0,
                                                                    _0: undefined
                                                                  });
                                                      }
                                                      var scrollableElement$1 = Caml_option.valFromOption(scrollableElement);
                                                      return scrollVerticallyToLoadAllElements(context, scrollableElement$1).then(function (param) {
                                                                  return search1(useInnerText, maybeInnerTextSemantic, context, {
                                                                              TAG: /* Element */0,
                                                                              _0: scrollableElement$1,
                                                                              _1: indexOfLastScrollableElement
                                                                            }, selectorFromScrollableElement, addOnPredicateTimedOutCallback, domTree, onlyConsiderElementChainIf, includeElementsNotVisible, undefined);
                                                                });
                                                    });
                                        });
                            }));
              });
  };
  var search2 = function (useInnerText, maybeInnerTextSemantic, context, queryRoot, selector, addOnPredicateTimedOutCallback) {
    if (useInnerText && shouldOnlySearchViaInnerText(selector)) {
      Curry._1(Log$SmartcutsMacros.selector.log1, "Searching via innerText");
      var match = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, param) {
            var selectorReversed = List.rev(selector);
            return OptionUtils$SmartcutsMacros.withDefault(Promise.resolve({
                            TAG: /* Ok */0,
                            _0: undefined
                          }), Belt_Option.map(Belt_List.get(selectorReversed, 0), (function (param) {
                              var innerText = param.innerText;
                              var maybeTagName = param.tagName;
                              if (typeof innerText === "number") {
                                return Promise.resolve({
                                            TAG: /* Ok */0,
                                            _0: undefined
                                          });
                              }
                              if (maybeTagName === undefined) {
                                return Promise.resolve({
                                            TAG: /* Ok */0,
                                            _0: undefined
                                          });
                              }
                              if (innerText._0.trim() === "") {
                                return Promise.resolve({
                                            TAG: /* Ok */0,
                                            _0: undefined
                                          });
                              }
                              var normalizedTextCriteria = $$String.lowercase_ascii(innerText._0.trim());
                              var applyToAppropriateElements = maybeTagName === "a" ? XPath$SmartcutsMacros.ExpressionBuilder.elementWithOrDescendantElementsWith : (function (builder) {
                                    return builder;
                                  });
                              var xpath = "//" + (maybeTagName + ("[" + (Curry._1(applyToAppropriateElements, XPath$SmartcutsMacros.ExpressionBuilder.equals(normalizedTextCriteria, XPath$SmartcutsMacros.ExpressionBuilder.lowercase(XPath$SmartcutsMacros.ExpressionBuilder.normalizeSpace(XPath$SmartcutsMacros.ExpressionBuilder.text)))) + "]")));
                              return Curry._4(RunTime.queryXPath, context, queryRoot, addCancelCallback, xpath).then(function (elements) {
                                            Curry._3(Log$SmartcutsMacros.selector.log3, "xpath", xpath, elements);
                                            var len = elements.length;
                                            if (len !== 1) {
                                              if (len !== 0) {
                                                return Curry._2(RunTime.fetchDomTree, context, addCancelCallback).then(function (maybeDomTree) {
                                                            var getParentElements = function (elements) {
                                                              if (maybeDomTree !== undefined) {
                                                                return Curry._2(RunTime.getParentElements, Caml_option.valFromOption(maybeDomTree), elements);
                                                              } else {
                                                                return Belt_Array.map(elements, (function (param) {
                                                                              
                                                                            }));
                                                              }
                                                            };
                                                            return Util$SmartcutsMacros.shortcutPromise((function (maybeParentElement) {
                                                                          var match = ListUtils$SmartcutsMacros.getLast(selector);
                                                                          var match$1 = Belt_List.get(selectorReversed, 1);
                                                                          if (maybeParentElement === undefined) {
                                                                            return Promise.resolve(undefined);
                                                                          }
                                                                          if (match === undefined) {
                                                                            return Promise.resolve(undefined);
                                                                          }
                                                                          if (match$1 === undefined) {
                                                                            return Promise.resolve(undefined);
                                                                          }
                                                                          var parentElement = Caml_option.valFromOption(maybeParentElement);
                                                                          return Curry._3(RunTime.couldElementMatchSelectorTreeNode, context, parentElement, match$1).then(function (couldMatch) {
                                                                                      if (couldMatch) {
                                                                                        return PromiseUtils$SmartcutsMacros.map(topDownSearch(innerText, maybeInnerTextSemantic, context, {
                                                                                                        TAG: /* Element */0,
                                                                                                        _0: parentElement,
                                                                                                        _1: undefined
                                                                                                      }, {
                                                                                                        hd: match,
                                                                                                        tl: /* [] */0
                                                                                                      }, addCancelCallback), (function (result_maybe_element) {
                                                                                                      if (result_maybe_element.TAG !== /* Ok */0) {
                                                                                                        return {
                                                                                                                TAG: /* Error */1,
                                                                                                                _0: result_maybe_element._0
                                                                                                              };
                                                                                                      }
                                                                                                      var element = result_maybe_element._0;
                                                                                                      if (element !== undefined) {
                                                                                                        return {
                                                                                                                TAG: /* Ok */0,
                                                                                                                _0: Caml_option.valFromOption(element)
                                                                                                              };
                                                                                                      }
                                                                                                      
                                                                                                    }));
                                                                                      } else {
                                                                                        return Promise.resolve(undefined);
                                                                                      }
                                                                                    });
                                                                        }), getParentElements(elements));
                                                          });
                                              } else {
                                                return Promise.resolve(undefined);
                                              }
                                            }
                                            var onlyElement = elements[0];
                                            return Promise.resolve({
                                                        TAG: /* Ok */0,
                                                        _0: onlyElement
                                                      });
                                          }).then(function (maybeResultElement) {
                                          if (maybeResultElement !== undefined) {
                                            if (maybeResultElement.TAG === /* Ok */0) {
                                              return Promise.resolve({
                                                          TAG: /* Ok */0,
                                                          _0: Caml_option.some(maybeResultElement._0)
                                                        });
                                            } else {
                                              return Promise.resolve({
                                                          TAG: /* Error */1,
                                                          _0: maybeResultElement._0
                                                        });
                                            }
                                          }
                                          var useInnerTextExactMatch = OptionUtils$SmartcutsMacros.andThen((function (leafNode) {
                                                  var match = leafNode.innerText;
                                                  if (typeof match === "number") {
                                                    return ;
                                                  } else {
                                                    return match;
                                                  }
                                                }), SelectorTree$SmartcutsMacros.maybeGetLeafNode(selector));
                                          return attemptToFindDeepestNode(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, addCancelCallback, selector).then(function (result_maybeElement) {
                                                      if (result_maybeElement.TAG !== /* Ok */0) {
                                                        return Promise.resolve({
                                                                    TAG: /* Error */1,
                                                                    _0: result_maybeElement._0
                                                                  });
                                                      }
                                                      var element = result_maybeElement._0;
                                                      if (element !== undefined) {
                                                        return Promise.resolve({
                                                                    TAG: /* Ok */0,
                                                                    _0: Caml_option.some(Caml_option.valFromOption(element))
                                                                  });
                                                      } else {
                                                        return topDownSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, selector, addCancelCallback);
                                                      }
                                                    });
                                        });
                            })));
          });
      Curry._1(addOnPredicateTimedOutCallback, match[1]);
      return Curry._1(match[0], undefined);
    }
    var match$1 = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, param) {
          return attemptToFindDeepestNode(undefined, undefined, context, queryRoot, addCancelCallback, selector).then(function (result_maybeResult) {
                      if (result_maybeResult.TAG !== /* Ok */0) {
                        return Promise.resolve({
                                    TAG: /* Error */1,
                                    _0: result_maybeResult._0
                                  });
                      }
                      var element = result_maybeResult._0;
                      if (element !== undefined) {
                        return Promise.resolve({
                                    TAG: /* Ok */0,
                                    _0: Caml_option.some(Caml_option.valFromOption(element))
                                  });
                      } else {
                        return topDownSearch(undefined, maybeInnerTextSemantic, context, queryRoot, selector, addCancelCallback);
                      }
                    });
        });
    Curry._1(addOnPredicateTimedOutCallback, match$1[1]);
    return Curry._1(match$1[0], undefined);
  };
  return {
          CandidateBranches: {
            ElementChain: {},
            init: init
          },
          search1: search1,
          searchWithScrolling: searchWithScrolling,
          search2: search2
        };
}

function getCurrentUrl(param) {
  return Promise.resolve(window.location.href);
}

function getDomShadowRoot(param, element) {
  return Caml_option.some(element.shadowRoot);
}

function getElementAttributes(param, element) {
  return element.attributes;
}

function idFromAttributes(attributes) {
  return OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt(attributes.getNamedItem("id")), (function (prim) {
                return prim.value;
              }));
}

function classNamesFromAttributes(attributes) {
  var arg = OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt(attributes.getNamedItem("class")), (function (attr) {
          return Belt_Array.keepMap(attr.value.split(/\s+/), (function (x) {
                        return x;
                      }));
        }));
  var param = [];
  return OptionUtils$SmartcutsMacros.withDefault(param, arg);
}

function keepAttributes(f, attributes) {
  var numAttributes = attributes.length;
  return Belt_MapString.fromArray(Belt_Array.keepMap(Belt_Array.mapWithIndex(Caml_array.make(numAttributes, undefined), (function (i, param) {
                        var attr = attributes.item(i);
                        if (!(attr == null)) {
                          return [
                                  attr.name,
                                  attr.value
                                ];
                        }
                        
                      })), (function (maybeKV) {
                    return OptionUtils$SmartcutsMacros.andThen((function (kv) {
                                  if (Curry._2(f, kv[0], kv[1])) {
                                    return kv;
                                  }
                                  
                                }), maybeKV);
                  })));
}

function querySelectorAll(param, queryRoot, param$1, includeElementsNotVisible, selectorExpression) {
  var nodesFound;
  nodesFound = typeof queryRoot === "number" ? document.querySelectorAll(selectorExpression) : queryRoot._0.querySelectorAll(selectorExpression);
  var result = [];
  nodesFound.forEach(function (node, _index) {
        var element = Webapi__Dom__Element.ofNode(node);
        if (element === undefined) {
          return ;
        }
        var element$1 = Caml_option.valFromOption(element);
        if (!includeElementsNotVisible && DOM__Element$SmartcutsMacros.isNotVisibleOnPage(element$1)) {
          return ;
        } else {
          result.push(element$1);
          return ;
        }
      });
  return Promise.resolve({
              TAG: /* Ok */0,
              _0: result
            });
}

function queryXPath(param, queryRoot, param$1, xpath) {
  var partial_arg = typeof queryRoot === "number" ? document : queryRoot._0;
  var func = function (param, param$1, param$2, param$3) {
    return DOM__Document$SmartcutsMacros.evaluate(xpath, partial_arg, param, param$1, param$2, param$3);
  };
  var result = Curry._4(func, undefined, /* ORDERED_NODE_SNAPSHOT_TYPE */7, undefined, document);
  var snapshotResult = XPath$SmartcutsMacros.Result.classify(result);
  if (snapshotResult.TAG !== /* OrderedNodeSnapshotResult */7) {
    return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected resultType: ORDERED_NODE_SNAPSHOT_TYPE");
  }
  var snapshotResult$1 = snapshotResult._0;
  return Promise.resolve($$Array.mapi((function (i, param) {
                    var arg = Curry._2(XPath$SmartcutsMacros.Result.SnapshotResult.snapshotItem, snapshotResult$1, i);
                    var arg$1 = (function (param) {
                          return OptionUtils$SmartcutsMacros.andThen(param, arg);
                        })(Webapi__Dom__Element.ofNode);
                    var param$1 = "Expected node to be an element";
                    return OptionUtils$SmartcutsMacros.getExn(param$1, arg$1);
                  }), Caml_array.make(snapshotResult$1.snapshotLength, 0)));
}

function getTagName(param, element) {
  return Promise.resolve(element.tagName);
}

function isVisibleOnPage(param, element) {
  return Promise.resolve(DOM__Element$SmartcutsMacros.isVisibleOnPage(element));
}

function fetchDomTree(param, param$1) {
  return Promise.resolve(Caml_option.some(undefined));
}

function getParentElement(param, element) {
  var arg = element.parentElement;
  var arg$1 = (arg == null) ? undefined : Caml_option.some(arg);
  var param$1 = function (element) {
    var match = element.nodeName;
    if (match === "HTML") {
      return ;
    } else {
      return Caml_option.some(element);
    }
  };
  return OptionUtils$SmartcutsMacros.andThen(param$1, arg$1);
}

function getParentChain(param, element) {
  var chain = [];
  var currNode = element;
  var $$break = false;
  while(!$$break) {
    chain = $$Array.append([currNode], chain);
    var parentNode = currNode.parentNode;
    if ((parentNode == null) || Caml_obj.caml_equal(OptionUtils$SmartcutsMacros.map(Webapi__Dom__Element.ofNode(parentNode), (function (prim) {
                  return prim.tagName;
                })), "HTML")) {
      $$break = true;
    } else {
      currNode = parentNode;
    }
  };
  return Belt_Array.map(chain, (function (prim) {
                return prim;
              }));
}

function getParentElements(param, elements) {
  return Belt_Array.map(elements, (function (prim) {
                return Caml_option.nullable_to_opt(prim.parentElement);
              }));
}

function getSiblingIndex(param, element) {
  var parent = element.parentElement;
  if (parent == null) {
    return 1;
  }
  var arg = Belt_Array.getIndexBy(Array.prototype.slice.call(parent.children), (function (child) {
          return child === element;
        }));
  return 1 + (function (param) {
              return OptionUtils$SmartcutsMacros.withDefault(param, arg);
            })(0) | 0;
}

function getUpdatedElementFromDomTree(param, element) {
  return element;
}

function getInnerTextForElement(param, param$1, element) {
  return Promise.resolve(HTMLNodes$SmartcutsMacros.InnerText.fromString(element.innerText));
}

function couldElementMatchSelectorTreeNode(param, element, node) {
  return Promise.resolve(Caml_obj.caml_equal($$String.lowercase_ascii(element.tagName), node.tagName));
}

function shouldRetryForJsPromiseError(param, _jsPromiseError) {
  return false;
}

function isElementEqualTo(elementA, elementB) {
  return elementA === elementB;
}

function getScrollHeight(param, element) {
  return Promise.resolve(element.scrollHeight);
}

function getClientHeight(param, element) {
  return Promise.resolve(element.clientHeight);
}

function getOverflowYForElement(param, element) {
  return Promise.resolve(window.getComputedStyle(element).overflowY);
}

function scrollTo(param, maybeScrollToX, maybeScrollToY, element) {
  var scrollLeft = element.scrollLeft;
  var scrollTop = element.scrollTop;
  var arg = Belt_Option.map(maybeScrollToX, (function (prim) {
          return prim;
        }));
  var scrollToX = (function (param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
      })(scrollLeft);
  var arg$1 = Belt_Option.map(maybeScrollToY, (function (prim) {
          return prim;
        }));
  var scrollToY = (function (param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
      })(scrollTop);
  element.scrollTo(scrollToX, scrollToY);
  return new Promise((function (resolve, param) {
                  var _lastScrollLeft = scrollLeft;
                  var _lastScrollTop = scrollTop;
                  while(true) {
                    var lastScrollTop = _lastScrollTop;
                    var lastScrollLeft = _lastScrollLeft;
                    var scrollLeft$1 = element.scrollLeft;
                    var scrollTop$1 = element.scrollTop;
                    if (scrollLeft$1 === lastScrollLeft && scrollTop$1 === lastScrollTop || scrollLeft$1 === scrollToX && scrollTop$1 === scrollToY) {
                      return resolve([
                                  scrollLeft$1,
                                  scrollTop$1
                                ]);
                    }
                    _lastScrollTop = scrollTop$1;
                    _lastScrollLeft = scrollLeft$1;
                    continue ;
                  };
                })).then(function (param) {
              return Promise.resolve(undefined);
            });
}

var WebPage = {
  getCurrentUrl: getCurrentUrl,
  getDomShadowRoot: getDomShadowRoot,
  getElementAttributes: getElementAttributes,
  idFromAttributes: idFromAttributes,
  classNamesFromAttributes: classNamesFromAttributes,
  keepAttributes: keepAttributes,
  querySelectorAll: querySelectorAll,
  maxRetries: 3,
  queryXPath: queryXPath,
  getTagName: getTagName,
  isVisibleOnPage: isVisibleOnPage,
  fetchDomTree: fetchDomTree,
  getParentElement: getParentElement,
  getParentChain: getParentChain,
  getParentElements: getParentElements,
  getSiblingIndex: getSiblingIndex,
  getUpdatedElementFromDomTree: getUpdatedElementFromDomTree,
  getInnerTextForElement: getInnerTextForElement,
  couldElementMatchSelectorTreeNode: couldElementMatchSelectorTreeNode,
  shouldRetryForJsPromiseError: shouldRetryForJsPromiseError,
  isElementEqualTo: isElementEqualTo,
  getScrollHeight: getScrollHeight,
  getClientHeight: getClientHeight,
  getOverflowYForElement: getOverflowYForElement,
  scrollTo: scrollTo
};

function doesElementMatchFullInnerText(fullTextToMatch, context, compareFullInnerTextToExpectedFullInnerText, compareTruncatedInnerTextToExpectedFullInnerText, addCancelCallback, element) {
  var match = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, isCanceled) {
        if (isCanceled.contents) {
          throw {
                RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                Error: new Error()
              };
        }
        return getInnerTextForElement(context, addCancelCallback, element);
      });
  Curry._1(addCancelCallback, match[1]);
  return Curry._1(match[0], undefined).then(function (innerText) {
              var tmp;
              if (typeof innerText === "number") {
                tmp = innerText === /* Ignored */0 ? true : false;
              } else if (innerText.TAG === /* FullInnerText */0) {
                var normalizedText = $$String.lowercase_ascii(innerText._0.trim());
                var normalizedExpectedText = $$String.lowercase_ascii(fullTextToMatch.trim());
                tmp = Curry._2(compareFullInnerTextToExpectedFullInnerText, normalizedText, normalizedExpectedText);
              } else {
                var prefix = innerText._0;
                var normalizedPrefix = $$String.lowercase_ascii(prefix.trim());
                tmp = Curry._3(compareTruncatedInnerTextToExpectedFullInnerText, normalizedPrefix, innerText._1 - (prefix.length - normalizedPrefix.length | 0) | 0, $$String.lowercase_ascii(fullTextToMatch.trim()));
              }
              return Promise.resolve(tmp);
            });
}

function doesElementMatchInnerText(maybeUseInnerTextExactMatch, maybeInnerTextSemantic, context, compareFullInnerTextToExpectedFullInnerText, compareFullInnerTextToExpectedTruncatedInnerText, compareTruncatedInnerTextToExpectedFullInnerText, compareTruncatedInnerTextToExpectedTruncatedInnerText, addCancelCallback, element) {
  if (maybeUseInnerTextExactMatch === undefined) {
    return Promise.resolve(true);
  }
  if (typeof maybeUseInnerTextExactMatch === "number") {
    if (maybeUseInnerTextExactMatch === /* Ignored */0) {
      if (maybeInnerTextSemantic === undefined) {
        return Promise.resolve(true);
      }
      if (typeof maybeInnerTextSemantic !== "number" && maybeInnerTextSemantic.TAG === /* VariableInnerText */5) {
        return Promise.resolve(true);
      }
      
    } else if (maybeInnerTextSemantic !== undefined) {
      if (typeof maybeInnerTextSemantic !== "number" && maybeInnerTextSemantic.TAG === /* VariableInnerText */5) {
        return Promise.resolve(false);
      }
      
    } else {
      var match = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, isCanceled) {
            if (isCanceled.contents) {
              throw {
                    RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                    Error: new Error()
                  };
            }
            return getInnerTextForElement(context, addCancelCallback, element);
          });
      Curry._1(addCancelCallback, match[1]);
      return Curry._1(match[0], undefined).then(function (innerText) {
                  var tmp;
                  tmp = typeof innerText === "number" ? true : innerText._0 === "";
                  return Promise.resolve(tmp);
                });
    }
  } else if (maybeUseInnerTextExactMatch.TAG === /* FullInnerText */0) {
    var fullTextToMatch = maybeUseInnerTextExactMatch._0;
    if (maybeInnerTextSemantic === undefined) {
      return doesElementMatchFullInnerText(fullTextToMatch, context, compareFullInnerTextToExpectedFullInnerText, compareTruncatedInnerTextToExpectedFullInnerText, addCancelCallback, element);
    }
    if (typeof maybeInnerTextSemantic !== "number" && maybeInnerTextSemantic.TAG === /* VariableInnerText */5) {
      return doesElementMatchFullInnerText(fullTextToMatch, context, compareFullInnerTextToExpectedFullInnerText, compareTruncatedInnerTextToExpectedFullInnerText, addCancelCallback, element);
    }
    
  } else {
    var prefixToMatch = maybeUseInnerTextExactMatch._0;
    if (maybeInnerTextSemantic !== undefined) {
      if (typeof maybeInnerTextSemantic !== "number" && maybeInnerTextSemantic.TAG === /* VariableInnerText */5) {
        return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected pairing with VariableInnerText: " + HTMLNodes$SmartcutsMacros.InnerText.stringify(maybeUseInnerTextExactMatch));
      }
      
    } else {
      var normalizedPrefixToMatch = $$String.lowercase_ascii(prefixToMatch.trim());
      var normalizedOriginalLength = maybeUseInnerTextExactMatch._1 - (prefixToMatch.length - normalizedPrefixToMatch.length | 0) | 0;
      var match$1 = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, isCanceled) {
            if (isCanceled.contents) {
              throw {
                    RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                    Error: new Error()
                  };
            }
            return getInnerTextForElement(context, addCancelCallback, element);
          });
      Curry._1(addCancelCallback, match$1[1]);
      return Curry._1(match$1[0], undefined).then(function (innerText) {
                  var tmp;
                  if (typeof innerText === "number") {
                    tmp = innerText === /* Ignored */0 ? true : false;
                  } else if (innerText.TAG === /* FullInnerText */0) {
                    var normalizedFullText = $$String.lowercase_ascii(innerText._0.trim());
                    tmp = Curry._3(compareFullInnerTextToExpectedTruncatedInnerText, normalizedFullText, normalizedPrefixToMatch, normalizedOriginalLength);
                  } else {
                    var prefix2 = innerText._0;
                    var normalizedPrefix2 = $$String.lowercase_ascii(prefix2.trim());
                    var normalizedLength2 = innerText._1 - (prefix2.length - normalizedPrefix2.length | 0) | 0;
                    tmp = Curry._4(compareTruncatedInnerTextToExpectedTruncatedInnerText, normalizedPrefix2, normalizedLength2, normalizedPrefixToMatch, normalizedOriginalLength);
                  }
                  return Promise.resolve(tmp);
                });
    }
  }
  if (typeof maybeInnerTextSemantic === "number") {
    return Promise.resolve(true);
  }
  switch (maybeInnerTextSemantic.TAG | 0) {
    case /* MatchesFullInnerText */0 :
        var fullTextToMatch$1 = Curry._1(DataDependency$SmartcutsMacros.DataRef.resolveAsText, maybeInnerTextSemantic._0);
        return doesElementMatchFullInnerText(fullTextToMatch$1, context, compareFullInnerTextToExpectedFullInnerText, compareTruncatedInnerTextToExpectedFullInnerText, addCancelCallback, element);
    case /* MatchesInnerTextPrefix */1 :
        var stringThatShouldPrefixInnerText = Curry._1(DataDependency$SmartcutsMacros.DataRef.resolveAsText, maybeInnerTextSemantic._0);
        var match$2 = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, isCanceled) {
              if (isCanceled.contents) {
                throw {
                      RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                      Error: new Error()
                    };
              }
              return getInnerTextForElement(context, addCancelCallback, element);
            });
        Curry._1(addCancelCallback, match$2[1]);
        return Curry._1(match$2[0], undefined).then(function (innerText) {
                    var tmp;
                    if (typeof innerText === "number") {
                      tmp = innerText === /* Ignored */0 ? true : false;
                    } else if (innerText.TAG === /* FullInnerText */0) {
                      tmp = innerText._0.startsWith(stringThatShouldPrefixInnerText);
                    } else {
                      var prefix = innerText._0;
                      if (prefix.length > stringThatShouldPrefixInnerText.length) {
                        tmp = prefix.includes(stringThatShouldPrefixInnerText);
                      } else {
                        var truncatedStringThatShouldPrefixInnerText = stringThatShouldPrefixInnerText.slice(0, prefix.length);
                        tmp = truncatedStringThatShouldPrefixInnerText === prefix && truncatedStringThatShouldPrefixInnerText.length <= innerText._1;
                      }
                    }
                    return Promise.resolve(tmp);
                  });
    case /* ContainsInnerText */2 :
        var stringThatShouldBeInsideInnerText = Curry._1(DataDependency$SmartcutsMacros.DataRef.resolveAsText, maybeInnerTextSemantic._0);
        var match$3 = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, isCanceled) {
              if (isCanceled.contents) {
                throw {
                      RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                      Error: new Error()
                    };
              }
              return getInnerTextForElement(context, addCancelCallback, element);
            });
        Curry._1(addCancelCallback, match$3[1]);
        return Curry._1(match$3[0], undefined).then(function (innerText) {
                    var tmp;
                    if (typeof innerText === "number") {
                      tmp = innerText === /* Ignored */0 ? true : false;
                    } else if (innerText.TAG === /* FullInnerText */0) {
                      tmp = innerText._0.includes(stringThatShouldBeInsideInnerText);
                    } else {
                      var prefix = innerText._0;
                      if (prefix.length > stringThatShouldBeInsideInnerText.length) {
                        tmp = prefix.includes(stringThatShouldBeInsideInnerText);
                      } else {
                        console.warn("Unhandled ContainsInnerText against TruncatedInnerText");
                        tmp = false;
                      }
                    }
                    return Promise.resolve(tmp);
                  });
    case /* ContainsInnerTextEnum */3 :
        var possibleMatchingSubstrings = $$Array.append([
              maybeInnerTextSemantic._0,
              maybeInnerTextSemantic._1
            ], maybeInnerTextSemantic._2);
        var match$4 = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, isCanceled) {
              if (isCanceled.contents) {
                throw {
                      RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                      Error: new Error()
                    };
              }
              return getInnerTextForElement(context, addCancelCallback, element);
            });
        Curry._1(addCancelCallback, match$4[1]);
        return Curry._1(match$4[0], undefined).then(function (innerText) {
                    var tmp;
                    if (typeof innerText === "number") {
                      tmp = innerText === /* Ignored */0 ? true : false;
                    } else if (innerText.TAG === /* FullInnerText */0) {
                      var fullText = innerText._0;
                      tmp = Belt_Array.some(possibleMatchingSubstrings, (function (substring) {
                              return fullText.includes(substring);
                            }));
                    } else {
                      var prefix = innerText._0;
                      tmp = Belt_Array.some(possibleMatchingSubstrings, (function (substring) {
                              if (prefix.length > substring.length) {
                                return prefix.includes(substring);
                              } else {
                                console.warn("Unhandled ContainsInnerTextEnum against TruncatedInnerText");
                                return false;
                              }
                            }));
                    }
                    return Promise.resolve(tmp);
                  });
    case /* ContainsInnerTextAllStrings */4 :
        var allRequiredSubstrings = $$Array.append([
              maybeInnerTextSemantic._0,
              maybeInnerTextSemantic._1
            ], maybeInnerTextSemantic._2);
        var match$5 = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, isCanceled) {
              if (isCanceled.contents) {
                throw {
                      RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                      Error: new Error()
                    };
              }
              return getInnerTextForElement(context, addCancelCallback, element);
            });
        Curry._1(addCancelCallback, match$5[1]);
        return Curry._1(match$5[0], undefined).then(function (innerText) {
                    var tmp;
                    if (typeof innerText === "number") {
                      tmp = innerText === /* Ignored */0 ? true : false;
                    } else if (innerText.TAG === /* FullInnerText */0) {
                      var fullText = innerText._0;
                      tmp = Belt_Array.every(allRequiredSubstrings, (function (substring) {
                              return fullText.includes(substring);
                            }));
                    } else {
                      var prefix = innerText._0;
                      tmp = Belt_Array.every(allRequiredSubstrings, (function (substring) {
                              if (prefix.length > substring.length) {
                                return prefix.includes(substring);
                              } else {
                                console.warn("Unhandled ContainsInnerTextAllStrings against TruncatedInnerText");
                                return false;
                              }
                            }));
                    }
                    return Promise.resolve(tmp);
                  });
    
  }
}

function arg(text, expectedText) {
  return text === expectedText;
}

function arg$1(text, expectedPrefix, param) {
  return text.startsWith(expectedPrefix);
}

function arg$2(prefix, length, expectedText) {
  if (expectedText.startsWith(prefix)) {
    return length === expectedText.length;
  } else {
    return false;
  }
}

function arg$3(prefix, length, expectedPrefix, expectedOriginalLength) {
  if (length === expectedOriginalLength) {
    if (prefix.length >= expectedPrefix.length) {
      return prefix.startsWith(expectedPrefix);
    } else {
      return expectedPrefix.startsWith(prefix);
    }
  } else {
    return false;
  }
}

function doesElementMatchInnerTextExactly(param) {
  return function (param$1) {
    var func = function (param$2, param$3, param$4, param$5, param$6, param$7, param$8) {
      return doesElementMatchInnerText(param, param$1, param$2, param$3, param$4, param$5, param$6, param$7, param$8);
    };
    return function (param) {
      return Curry._5(func, param, arg, arg$1, arg$2, arg$3);
    };
  };
}

function arg$4(text, expectedText) {
  return text.includes(expectedText);
}

function arg$5(text, expectedPrefix, expectedOriginalLength) {
  if (text.includes(expectedPrefix)) {
    return text.length >= expectedOriginalLength;
  } else {
    return false;
  }
}

function arg$6(prefix, length, expectedText) {
  if (prefix.includes(expectedText)) {
    return length >= expectedText.length;
  } else {
    return false;
  }
}

function arg$7(prefix, length, expectedPrefix, expectedOriginalLength) {
  if (prefix.startsWith(expectedPrefix)) {
    return length >= expectedOriginalLength;
  } else {
    return false;
  }
}

function doesElementIncludeInnerText(param) {
  return function (param$1) {
    var func = function (param$2, param$3, param$4, param$5, param$6, param$7, param$8) {
      return doesElementMatchInnerText(param, param$1, param$2, param$3, param$4, param$5, param$6, param$7, param$8);
    };
    return function (param) {
      return Curry._5(func, param, arg$4, arg$5, arg$6, arg$7);
    };
  };
}

function keepElementsThatMatchInnerTextExactly(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, elements) {
  return Promise.all($$Array.mapi((function (index, element) {
                      return Curry._3(doesElementMatchInnerTextExactly(useInnerTextExactMatch)(maybeInnerTextSemantic), context, addCancelCallback, element).then(function (doesMatch) {
                                  return Promise.resolve([
                                              doesMatch,
                                              Caml_array.get(elements, index)
                                            ]);
                                });
                    }), elements)).then(function (pairsOfDoesMatchAndElement) {
              return Promise.resolve(Belt_Array.map(Belt_Array.keep(pairsOfDoesMatchAndElement, (function (param) {
                                    return param[0];
                                  })), (function (prim) {
                                return prim[1];
                              })));
            });
}

function onlyKeepVisibleElements(context, addCancelCallback, elements) {
  return ArrayUtils$SmartcutsMacros.keepAsync((function (element) {
                return PromiseUtils$SmartcutsMacros.makePromiseCancelableBySurroundingPromise(addCancelCallback, (function (param) {
                              return Promise.resolve(DOM__Element$SmartcutsMacros.isVisibleOnPage(element));
                            }));
              }), elements);
}

function checkIsOptionElement(context, element) {
  return Promise.resolve(element.tagName).then(function (maybeTagName) {
              return Promise.resolve(Caml_obj.caml_equal(maybeTagName, "OPTION"));
            });
}

function onlyKeepVisibleElementsOrOptionElements(context, addCancelCallback, elements) {
  return ArrayUtils$SmartcutsMacros.keepAsync((function (element) {
                return PromiseUtils$SmartcutsMacros.makePromiseCancelableBySurroundingPromise(addCancelCallback, (function (param) {
                              return checkIsOptionElement(context, element).then(function (isOptionElement) {
                                          if (isOptionElement) {
                                            return Promise.resolve(true);
                                          } else {
                                            return Promise.resolve(DOM__Element$SmartcutsMacros.isVisibleOnPage(element));
                                          }
                                        });
                            }));
              }), elements);
}

function isElementScrollable(context, element) {
  return PromiseUtils$SmartcutsMacros.resolveWith((function (param) {
                var hasScrollableContent = param[0] > param[1];
                var isOverflowHidden = param[2].includes("hidden");
                if (hasScrollableContent) {
                  return !isOverflowHidden;
                } else {
                  return false;
                }
              }), Promise.all([
                  Promise.resolve(element.scrollHeight),
                  Promise.resolve(element.clientHeight),
                  getOverflowYForElement(context, element)
                ]));
}

function getElementsWithSameDepthAndAttributeKeysAsSelector(queryRoot, context, useInnerText, maybeInnerTextSemantic, attributesExistencePredicate, leafSelectorNode, addCancelCallback, domTree, selector, includeElementsNotVisible, param) {
  var attributesFilter;
  if (typeof attributesExistencePredicate === "number") {
    switch (attributesExistencePredicate) {
      case /* AllAttributes */0 :
          attributesFilter = (function (_selectorNodeIndex, _attrName) {
              return true;
            });
          break;
      case /* AttributesNotDataOrAria */1 :
          attributesFilter = (function (_selectorNodeIndex, attrName) {
              return !(attrName.startsWith("data-") || attrName.startsWith("aria-"));
            });
          break;
      case /* OnlyUseId */2 :
          attributesFilter = (function (_selectorNodeIndex, attrName) {
              return attrName === "id";
            });
          break;
      
    }
  } else {
    var nLevels = attributesExistencePredicate._0;
    attributesFilter = (function (selectorNodeIndex, attrName) {
        if (attrName === "class") {
          return (List.length(selector) - selectorNodeIndex | 0) > nLevels;
        } else {
          return !(attrName.startsWith("data-") || attrName.startsWith("aria-"));
        }
      });
  }
  return Promise.resolve(window.location.href).then(function (currentUrl) {
                var cssSelector = Selector$SmartcutsMacros.toCssSelectorUsingTagChainAndAttributeExistence(queryRoot !== /* Document */0, attributesFilter, currentUrl, selector);
                var tagName = leafSelectorNode.tagName;
                return querySelectorAll(context, queryRoot, domTree, tagName !== undefined && $$String.lowercase_ascii(tagName) === "option" ? true : includeElementsNotVisible, cssSelector);
              }).then(function (result_matches) {
              if (result_matches.TAG !== /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: result_matches._0
                          });
              }
              var matches = result_matches._0;
              var tmp;
              if (useInnerText) {
                var param = leafSelectorNode.innerText;
                var func = function (param$1, param$2, param$3, param$4) {
                  return keepElementsThatMatchInnerTextExactly(param, param$1, param$2, param$3, param$4);
                };
                tmp = Curry._2((function (param) {
                          var func$1 = Curry._1(func, param);
                          return function (param) {
                            var func$2 = Curry._1(func$1, param);
                            return function (param) {
                              return Curry._2(func$2, param, matches);
                            };
                          };
                        })(maybeInnerTextSemantic), context, addCancelCallback);
              } else {
                tmp = Promise.resolve(matches);
              }
              return tmp.then(function (elements) {
                          if (includeElementsNotVisible) {
                            return Promise.resolve({
                                        TAG: /* Ok */0,
                                        _0: elements
                                      });
                          } else {
                            return onlyKeepVisibleElementsOrOptionElements(context, addCancelCallback, elements).then(function (matches) {
                                        return Promise.resolve({
                                                    TAG: /* Ok */0,
                                                    _0: matches
                                                  });
                                      });
                          }
                        });
            });
}

function calcDistanceBetweenBetweenIds(elementAttributes, selectorNode) {
  var match = idFromAttributes(elementAttributes);
  var match$1 = selectorNode.id;
  if (match === undefined) {
    if (match$1 !== undefined) {
      return 1000;
    } else {
      return 0;
    }
  }
  if (match$1 === undefined) {
    return 10;
  }
  if (match === match$1) {
    return 0;
  }
  if (match.length === match$1.length) {
    return 10;
  }
  var _prefix = StringUtils$SmartcutsMacros.commonPrefix(match, match$1);
  if (_prefix !== undefined) {
    return 10;
  } else {
    return 1000;
  }
}

function calcDistanceBetweenBetweenClasses(elementAttributes, selectorNode) {
  var match = classNamesFromAttributes(elementAttributes);
  var match$1 = selectorNode.classNames;
  var exit = 0;
  if (match.length !== 0) {
    exit = 2;
  } else {
    if (match$1.length === 0) {
      return 0;
    }
    if (match$1.length !== 0) {
      return 1000;
    }
    exit = 2;
  }
  if (exit === 2 && match$1.length === 0 && match.length !== 0) {
    return 1000;
  }
  var elementClassNamesSet = Belt_SetString.fromArray(match);
  var selectorClassNamesSet = Belt_SetString.fromArray(match$1);
  var commonClassNamesSet = Belt_SetString.intersect(elementClassNamesSet, selectorClassNamesSet);
  var elementClassNamesNotSharedBySelector = Belt_SetString.diff(elementClassNamesSet, selectorClassNamesSet);
  var selectorClassNamesNotSharedByElement = Belt_SetString.diff(selectorClassNamesSet, elementClassNamesSet);
  return (Math.imul(Belt_SetString.size(commonClassNamesSet), -10) + Math.imul(Belt_SetString.size(elementClassNamesNotSharedBySelector), 10) | 0) + Math.imul(Belt_SetString.size(selectorClassNamesNotSharedByElement), 10) | 0;
}

function calcDistanceBetweenAttributes(elementAttributes, selectorNode) {
  var elementAttributesThatAreNotIdOrClass = keepAttributes((function (attrName, _attrValue) {
          if (attrName !== "class" && attrName !== "id") {
            return !$$Array.mem(attrName, Selector$SmartcutsMacros.attributesToAvoidComparing);
          } else {
            return false;
          }
        }), elementAttributes);
  var selectorAttributes = Belt_Array.reduce(Selector$SmartcutsMacros.attributesToAvoidComparing, Belt_MapString.fromArray(selectorNode.attributes), Belt_MapString.remove);
  var match = Belt_MapString.size(elementAttributesThatAreNotIdOrClass);
  var match$1 = Belt_MapString.size(selectorAttributes);
  var exit = 0;
  if (match !== 0) {
    exit = 2;
  } else {
    if (match$1 === 0) {
      return 0;
    }
    if (match$1 > 0) {
      return 0;
    }
    exit = 2;
  }
  if (exit === 2 && match$1 === 0 && match > 0) {
    return 0;
  }
  var elementAttributeNames = Belt_SetString.fromArray(Belt_MapString.keysToArray(elementAttributesThatAreNotIdOrClass));
  var selectorAttributeNames = Belt_SetString.fromArray(Belt_MapString.keysToArray(selectorAttributes));
  var commonAttributeNamesSet = Belt_SetString.intersect(elementAttributeNames, selectorAttributeNames);
  var elementAttributeNamesNotSharedBySelector = Belt_SetString.diff(elementAttributeNames, selectorAttributeNames);
  var selectorAttributeNamesNotSharedByElement = Belt_SetString.diff(selectorAttributeNames, elementAttributeNames);
  return (Belt_Array.reduce(Belt_SetString.toArray(commonAttributeNamesSet), 0, (function (commonAttrDistance, attrName) {
                  var elementAttrVal = Belt_MapString.getExn(elementAttributesThatAreNotIdOrClass, attrName);
                  var selectorAttrVal = Belt_MapString.getExn(selectorAttributes, attrName);
                  var attributeValueDistance = FastLevenshtein.get(elementAttrVal, selectorAttrVal);
                  var tmp = attrName === "aria-label" ? (
                      attributeValueDistance === 0 ? -1000 : (
                          attributeValueDistance === 0 ? -10 : attributeValueDistance
                        )
                    ) : (
                      attributeValueDistance === 0 ? -10 : attributeValueDistance
                    );
                  return commonAttrDistance + tmp | 0;
                })) + Math.imul(Belt_SetString.size(elementAttributeNamesNotSharedBySelector), 10) | 0) + Math.imul(Belt_SetString.size(selectorAttributeNamesNotSharedByElement), 10) | 0;
}

function distanceIsScrollable(element, context, selectorNode) {
  return PromiseUtils$SmartcutsMacros.resolveWith((function (isElementScrollable) {
                var match = selectorNode.isScrollable;
                if (match !== undefined) {
                  if (match) {
                    if (isElementScrollable) {
                      return 1;
                    } else {
                      return 0;
                    }
                  } else if (isElementScrollable) {
                    return 0;
                  } else {
                    return 1;
                  }
                } else if (isElementScrollable) {
                  return 0;
                } else {
                  return 1;
                }
              }), isElementScrollable(context, element));
}

function distanceBetweenSelectorNodeAndElement(domTree, selectorNode, context, element) {
  var attributes = element.attributes;
  var distanceId = calcDistanceBetweenBetweenIds(attributes, selectorNode);
  var distanceClasses = calcDistanceBetweenBetweenClasses(attributes, selectorNode);
  var distanceAttributes = calcDistanceBetweenAttributes(attributes, selectorNode);
  return checkIsOptionElement(context, element).then(function (isOptionElement) {
              if (isOptionElement && Caml_obj.caml_equal(selectorNode.tagName, "option")) {
                return Promise.resolve([
                            Math.imul(distanceId, 100),
                            Math.imul(distanceClasses, 10),
                            (distanceAttributes << 0)
                          ]);
              } else {
                return PromiseUtils$SmartcutsMacros.resolveWith((function (distanceIsScrollable) {
                              return [
                                      Math.imul(distanceId, 100),
                                      Math.imul(distanceClasses, 10),
                                      (distanceAttributes << 0),
                                      Math.imul(distanceIsScrollable, 50)
                                    ];
                            }), distanceIsScrollable(element, context, selectorNode));
              }
            });
}

function calcForElementChain(domTree, selector, context, elementChain) {
  var depthDistance = Math.abs(List.length(selector) - elementChain.length | 0);
  if (depthDistance > 0) {
    return Promise.resolve(Math.pow(10, depthDistance + 2 | 0));
  } else {
    return PromiseUtils$SmartcutsMacros.resolveWith((function (distanceArray) {
                  Curry._2(Log$SmartcutsMacros.selector.warn2, "calcForElementChain", Belt_Array.zip(elementChain, distanceArray));
                  var sumBy = function (f, xs) {
                    return Belt_Array.reduce(xs, 0.0, (function (acc, x) {
                                  return Curry._1(f, x) + acc;
                                }));
                  };
                  return sumBy((function (param) {
                                return sumBy((function (x) {
                                              return x;
                                            }), param);
                              }), distanceArray);
                }), Belt_List.reduceWithIndex(selector, Promise.resolve([]), (function (promise, selectorNode, index) {
                      return PromiseUtils$SmartcutsMacros.resolveWith((function (param) {
                                    return Belt_Array.concat(param[0], [param[1]]);
                                  }), Promise.all([
                                      promise,
                                      distanceBetweenSelectorNodeAndElement(domTree, selectorNode, context, Caml_array.get(elementChain, index))
                                    ]));
                    })));
  }
}

function findElementsMatchingTagNameChainAndAttributesExistence(queryRoot, context, useInnerText, maybeInnerTextSemantic, leafSelectorNode, addCancelCallback, domTree, selector, includeElementsNotVisible, param) {
  var attributesExistencePredicateFallbacks = [
    /* AllAttributes */0,
    /* AttributesNotDataOrAria */1,
    /* StardardAttributesExceptClassNameAtLastNLevels */{
      _0: 3
    },
    /* OnlyUseId */2
  ];
  return PromiseUtils$SmartcutsMacros.map(ArrayUtils$SmartcutsMacros.shortcutAsync((function (attributesExistencePredicate) {
                    return PromiseUtils$SmartcutsMacros.map(getElementsWithSameDepthAndAttributeKeysAsSelector(queryRoot, context, useInnerText, maybeInnerTextSemantic, attributesExistencePredicate, leafSelectorNode, addCancelCallback, domTree, selector, includeElementsNotVisible, undefined), (function (result_matchingElements) {
                                  if (result_matchingElements.TAG !== /* Ok */0) {
                                    return {
                                            TAG: /* Error */1,
                                            _0: result_matchingElements._0
                                          };
                                  }
                                  var matchingElements = result_matchingElements._0;
                                  var match = matchingElements.length;
                                  if (match !== 0) {
                                    return {
                                            TAG: /* Ok */0,
                                            _0: matchingElements
                                          };
                                  }
                                  
                                }));
                  }), attributesExistencePredicateFallbacks), (function (maybe_result_matchingElements) {
                if (maybe_result_matchingElements !== undefined) {
                  if (maybe_result_matchingElements.TAG === /* Ok */0) {
                    return {
                            TAG: /* Ok */0,
                            _0: maybe_result_matchingElements._0
                          };
                  } else {
                    return {
                            TAG: /* Error */1,
                            _0: maybe_result_matchingElements._0
                          };
                  }
                } else {
                  return {
                          TAG: /* Ok */0,
                          _0: []
                        };
                }
              }));
}

function init(useInnerText, maybeInnerTextSemantic, queryRootOpt, context, addCancelCallback, maybeDomTree, maybeOnlyConsiderElementChainIf, includeElementsNotVisible, selector) {
  var queryRoot = queryRootOpt !== undefined ? queryRootOpt : /* Document */0;
  var arg = ListUtils$SmartcutsMacros.getLast(selector);
  var leafSelectorNode = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
      })("Expect to get leaf selector node");
  var selectorLength = List.length(selector);
  return findElementsMatchingTagNameChainAndAttributesExistence(queryRoot, context, useInnerText, maybeInnerTextSemantic, leafSelectorNode, addCancelCallback, maybeDomTree, selector, includeElementsNotVisible, undefined).then(function (result_matchingElements) {
              if (result_matchingElements.TAG !== /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: result_matchingElements._0
                          });
              }
              var matchingElements = result_matchingElements._0;
              return PromiseUtils$SmartcutsMacros.map(maybeDomTree !== undefined ? Promise.resolve(Caml_option.valFromOption(maybeDomTree)) : PromiseUtils$SmartcutsMacros.map(Promise.resolve(Caml_option.some(undefined)), (function (param) {
                                  return OptionUtils$SmartcutsMacros.getExn("Expect Some(domTree) when getting candidate branches", param);
                                })), (function (domTree) {
                            var updatedMatchingElements = Belt_Array.map(matchingElements, (function (param) {
                                    return param;
                                  }));
                            var arg = Belt_Array.map(updatedMatchingElements, (function (element) {
                                    var fullChain = getParentChain(domTree, element);
                                    if (typeof queryRoot === "number") {
                                      return fullChain;
                                    } else {
                                      var element$1 = queryRoot._0;
                                      var index = Belt_Array.getIndexBy(fullChain, (function (currElement) {
                                              return Caml_obj.caml_equal(currElement, element$1);
                                            }));
                                      if (index !== undefined) {
                                        return Belt_Array.sliceToEnd(fullChain, index + 1 | 0);
                                      } else {
                                        return fullChain;
                                      }
                                    }
                                  }));
                            return {
                                    TAG: /* Ok */0,
                                    _0: [
                                      Belt_Array.keep(Belt_Array.keep((function (param) {
                                                      return function (param$1) {
                                                        return Util$SmartcutsMacros.spyTransform(param, param$1, arg);
                                                      };
                                                    })("before chain length filter")(function (x) {
                                                    return x;
                                                  }), (function (elementChain) {
                                                  return elementChain.length === selectorLength;
                                                })), (function (elementChain) {
                                              if (maybeOnlyConsiderElementChainIf !== undefined) {
                                                return Curry._1(maybeOnlyConsiderElementChainIf, elementChain);
                                              } else {
                                                return true;
                                              }
                                            })),
                                      domTree
                                    ]
                                  };
                          }));
            });
}

var alwaysRequiredAttributeNames = [
  "autofocus",
  "role"
];

function factorOutRequiredAttributesFromNode(node) {
  var attributesByRequiredOrNotRequired = ArrayUtils$SmartcutsMacros.groupBy((function (param) {
          if ($$Array.mem(param[0], alwaysRequiredAttributeNames)) {
            return "required";
          } else {
            return "not-required";
          }
        }), node.attributes);
  var requiredAttributes = OptionUtils$SmartcutsMacros.withDefault([], Belt_MapString.get(attributesByRequiredOrNotRequired, "required"));
  var optionalAttributes = OptionUtils$SmartcutsMacros.withDefault([], Belt_MapString.get(attributesByRequiredOrNotRequired, "not-required"));
  return [
          requiredAttributes,
          {
            id: node.id,
            tagName: node.tagName,
            classNames: node.classNames,
            attributes: optionalAttributes,
            index: node.index,
            innerText: node.innerText,
            isScrollable: node.isScrollable,
            attributeBlacklist: node.attributeBlacklist
          }
        ];
}

function getNextCombinationForNode(_searchStrategy, requiredAttributes, selectorNodeWithoutRequiredAttributes) {
  while(true) {
    var searchStrategy = _searchStrategy;
    if (typeof searchStrategy === "number") {
      switch (searchStrategy) {
        case /* ByTagAndId */0 :
            var arg = selectorNodeWithoutRequiredAttributes.tagName;
            return {
                    combo: {
                      id: selectorNodeWithoutRequiredAttributes.id,
                      tagName: selectorNodeWithoutRequiredAttributes.tagName,
                      classNames: [],
                      attributes: [],
                      index: undefined,
                      innerText: /* NoInnerText */1,
                      isScrollable: undefined,
                      attributeBlacklist: []
                    },
                    nextStrategy: {
                      TAG: /* ByTagAndClassNames */0,
                      _0: {
                        tagName: (function(arg){
                          return function (param) {
                            return OptionUtils$SmartcutsMacros.getExn(param, arg);
                          }
                          }(arg))("Expected tagName"),
                        classComboGenerator: ComboGenerator$SmartcutsMacros.make($$Array.to_list(selectorNodeWithoutRequiredAttributes.classNames))
                      }
                    }
                  };
        case /* ByIndex */1 :
            var index = selectorNodeWithoutRequiredAttributes.index;
            if (index !== undefined) {
              return {
                      combo: {
                        id: undefined,
                        tagName: selectorNodeWithoutRequiredAttributes.tagName,
                        classNames: [],
                        attributes: $$Array.append(requiredAttributes, ArrayUtils$SmartcutsMacros.filterMap((function (param) {
                                    var key = param[0];
                                    if (key === "contenteditable") {
                                      return [
                                              key,
                                              param[1]
                                            ];
                                    }
                                    
                                  }), selectorNodeWithoutRequiredAttributes.attributes)),
                        index: index,
                        innerText: /* NoInnerText */1,
                        isScrollable: undefined,
                        attributeBlacklist: []
                      },
                      nextStrategy: /* NoMoreStrategies */2
                    };
            } else {
              return ;
            }
        case /* NoMoreStrategies */2 :
            return ;
        
      }
    } else {
      if (searchStrategy.TAG === /* ByTagAndClassNames */0) {
        var match = searchStrategy._0;
        var tagName = match.tagName;
        var match$1 = ComboGenerator$SmartcutsMacros.generateNextCombo(match.classComboGenerator);
        if (match$1 !== undefined) {
          return {
                  combo: {
                    id: undefined,
                    tagName: tagName,
                    classNames: $$Array.of_list(match$1[0]),
                    attributes: requiredAttributes,
                    index: undefined,
                    innerText: /* NoInnerText */1,
                    isScrollable: undefined,
                    attributeBlacklist: []
                  },
                  nextStrategy: {
                    TAG: /* ByTagAndClassNames */0,
                    _0: {
                      tagName: tagName,
                      classComboGenerator: match$1[1]
                    }
                  }
                };
        }
        _searchStrategy = {
          TAG: /* ByTagAndAttributes */1,
          _0: {
            tagName: tagName,
            attributeComboGenerator: ComboGenerator$SmartcutsMacros.make($$Array.to_list(selectorNodeWithoutRequiredAttributes.attributes))
          }
        };
        continue ;
      }
      var match$2 = searchStrategy._0;
      var tagName$1 = match$2.tagName;
      var match$3 = ComboGenerator$SmartcutsMacros.generateNextCombo(match$2.attributeComboGenerator);
      if (match$3 !== undefined) {
        return {
                combo: {
                  id: undefined,
                  tagName: tagName$1,
                  classNames: [],
                  attributes: $$Array.append(requiredAttributes, $$Array.of_list(match$3[0])),
                  index: undefined,
                  innerText: /* NoInnerText */1,
                  isScrollable: undefined,
                  attributeBlacklist: []
                },
                nextStrategy: {
                  TAG: /* ByTagAndAttributes */1,
                  _0: {
                    tagName: tagName$1,
                    attributeComboGenerator: match$3[1]
                  }
                }
              };
      }
      _searchStrategy = /* ByIndex */1;
      continue ;
    }
  };
}

function keepElementsThatIncludeInnerText(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, elements) {
  return Promise.all($$Array.mapi((function (index, element) {
                      return Curry._3(doesElementIncludeInnerText(useInnerTextExactMatch)(maybeInnerTextSemantic), context, addCancelCallback, element).then(function (doesMatch) {
                                  return Promise.resolve([
                                              doesMatch,
                                              Caml_array.get(elements, index)
                                            ]);
                                });
                    }), elements)).then(function (pairsOfDoesMatchAndElement) {
              return Promise.resolve(Belt_Array.map(Belt_Array.keep(pairsOfDoesMatchAndElement, (function (param) {
                                    return param[0];
                                  })), (function (prim) {
                                return prim[1];
                              })));
            });
}

function withQuerySelectorAll(retriesOpt, context, queryRoot, $$default, cssSelector, withResults) {
  var retries = retriesOpt !== undefined ? retriesOpt : 3;
  return PromiseUtils$SmartcutsMacros.withRetries(retries, (function (addCancelCallback, param) {
                return querySelectorAll(context, queryRoot, undefined, cssSelector.includes("option") || cssSelector.includes("select") || cssSelector.includes("[type=\"file\"]"), cssSelector).then(function (result_results) {
                            if (result_results.TAG !== /* Ok */0) {
                              return Promise.resolve({
                                          TAG: /* Error */1,
                                          _0: result_results._0
                                        });
                            }
                            var results = result_results._0;
                            var match = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, param) {
                                  return Curry._2(withResults, addCancelCallback, results);
                                });
                            Curry._1(addCancelCallback, match[1]);
                            return Curry._1(match[0], undefined);
                          });
              }), (function (param) {
                return false;
              }), {
              TAG: /* Ok */0,
              _0: $$default
            }, undefined);
}

function maybeFindMatch(useInnerTextExactMatch, maybeInnerTextSemantic, searchStrategy, requiredAttributes, context, queryRoot, addCancelCallback, selectorNodeWithoutRequiredAttributes) {
  var match = getNextCombinationForNode(searchStrategy, requiredAttributes, selectorNodeWithoutRequiredAttributes);
  if (match === undefined) {
    return Promise.resolve({
                TAG: /* Ok */0,
                _0: /* NoMatch */0
              });
  }
  var nextStrategy = match.nextStrategy;
  var arg_0 = match.combo;
  var arg = {
    hd: arg_0,
    tl: /* [] */0
  };
  var cssSelector = (function (param) {
        return SelectorTree$SmartcutsMacros.stringify(param, arg);
      })(queryRoot !== /* Document */0);
  var maybeFindMatchByUsingNextStrategy = function (param, param$1) {
    return maybeFindMatch(useInnerTextExactMatch, maybeInnerTextSemantic, nextStrategy, requiredAttributes, context, queryRoot, param, param$1);
  };
  var match$1 = withQuerySelectorAll(undefined, context, queryRoot, /* NoMatch */0, cssSelector, (function (addCancelCallback, results) {
          return onlyKeepVisibleElementsOrOptionElements(context, addCancelCallback, results).then(function (results) {
                      var _twoOrMore = results.length;
                      if (_twoOrMore === 0) {
                        return maybeFindMatchByUsingNextStrategy(addCancelCallback, selectorNodeWithoutRequiredAttributes);
                      }
                      if (_twoOrMore !== 1) {
                        return keepElementsThatIncludeInnerText(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, results).then(function (elementsThatIncludeInnerText) {
                                    var _twoOrMore = elementsThatIncludeInnerText.length;
                                    if (_twoOrMore !== 0) {
                                      if (_twoOrMore !== 1) {
                                        return keepElementsThatMatchInnerTextExactly(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, elementsThatIncludeInnerText).then(function (elementsThatMatchInnerTextExactly) {
                                                    var _twoOrMore = elementsThatMatchInnerTextExactly.length;
                                                    if (_twoOrMore !== 0) {
                                                      if (_twoOrMore !== 1) {
                                                        return Promise.resolve(undefined).then(function (maybeMatch) {
                                                                    if (maybeMatch !== undefined) {
                                                                      return Promise.resolve({
                                                                                  TAG: /* Ok */0,
                                                                                  _0: /* ExactMatch */{
                                                                                    _0: {
                                                                                      element: Caml_option.valFromOption(maybeMatch),
                                                                                      fallbackStrategy: nextStrategy
                                                                                    }
                                                                                  }
                                                                                });
                                                                    } else {
                                                                      return maybeFindMatchByUsingNextStrategy(addCancelCallback, selectorNodeWithoutRequiredAttributes);
                                                                    }
                                                                  });
                                                      } else {
                                                        return Promise.resolve({
                                                                    TAG: /* Ok */0,
                                                                    _0: /* ExactMatch */{
                                                                      _0: {
                                                                        element: Caml_array.get(elementsThatMatchInnerTextExactly, 0),
                                                                        fallbackStrategy: nextStrategy
                                                                      }
                                                                    }
                                                                  });
                                                      }
                                                    } else {
                                                      return maybeFindMatchByUsingNextStrategy(addCancelCallback, selectorNodeWithoutRequiredAttributes);
                                                    }
                                                  });
                                      } else {
                                        return Promise.resolve({
                                                    TAG: /* Ok */0,
                                                    _0: /* ExactMatch */{
                                                      _0: {
                                                        element: Caml_array.get(elementsThatIncludeInnerText, 0),
                                                        fallbackStrategy: nextStrategy
                                                      }
                                                    }
                                                  });
                                      }
                                    } else {
                                      return maybeFindMatchByUsingNextStrategy(addCancelCallback, selectorNodeWithoutRequiredAttributes);
                                    }
                                  });
                      }
                      var element = Caml_array.get(results, 0);
                      return Curry._3(doesElementMatchInnerTextExactly(useInnerTextExactMatch)(maybeInnerTextSemantic), context, addCancelCallback, element).then(function (doesMatch) {
                                  return Promise.resolve({
                                              TAG: /* Ok */0,
                                              _0: doesMatch ? /* ExactMatch */({
                                                    _0: {
                                                      element: element,
                                                      fallbackStrategy: nextStrategy
                                                    }
                                                  }) : /* NoMatch */0
                                            });
                                });
                    });
        }));
  Curry._1(addCancelCallback, match$1[1]);
  return Curry._1(match$1[0], undefined);
}

function isHtmlAttributeUsefulInOptimization(key, param) {
  if (key.startsWith("aria-")) {
    return true;
  } else {
    key.startsWith("data-");
    return false;
  }
}

function isSelectorNodeOptimalToBecomeNewQueryRoot(context, queryRoot, isLeafNode, addCancelCallback, selectorNode) {
  var id = selectorNode.id;
  if (id !== undefined) {
    var selectorNodeWithOnlyId_id = id;
    var selectorNodeWithOnlyId_tagName = selectorNode.tagName;
    var selectorNodeWithOnlyId_classNames = [];
    var selectorNodeWithOnlyId_attributes = [];
    var selectorNodeWithOnlyId_attributeBlacklist = [];
    var selectorNodeWithOnlyId = {
      id: selectorNodeWithOnlyId_id,
      tagName: selectorNodeWithOnlyId_tagName,
      classNames: selectorNodeWithOnlyId_classNames,
      attributes: selectorNodeWithOnlyId_attributes,
      index: undefined,
      innerText: /* NoInnerText */1,
      isScrollable: undefined,
      attributeBlacklist: selectorNodeWithOnlyId_attributeBlacklist
    };
    var cssSelector = SelectorTree$SmartcutsMacros.stringify(queryRoot !== /* Document */0, {
          hd: selectorNodeWithOnlyId,
          tl: /* [] */0
        });
    var match = withQuerySelectorAll(undefined, context, queryRoot, [
          false,
          []
        ], cssSelector, (function (addCancelCallback, results) {
            return onlyKeepVisibleElements(context, addCancelCallback, results).then(function (elements) {
                        var isOptimal = 1 === elements.length;
                        if (isOptimal) {
                          return Promise.resolve({
                                      TAG: /* Ok */0,
                                      _0: [
                                        isOptimal,
                                        elements
                                      ]
                                    });
                        } else {
                          return isSelectorNodeOptimalToBecomeNewQueryRoot(context, queryRoot, isLeafNode, addCancelCallback, {
                                      id: undefined,
                                      tagName: selectorNode.tagName,
                                      classNames: selectorNode.classNames,
                                      attributes: selectorNode.attributes,
                                      index: selectorNode.index,
                                      innerText: selectorNode.innerText,
                                      isScrollable: selectorNode.isScrollable,
                                      attributeBlacklist: selectorNode.attributeBlacklist
                                    });
                        }
                      });
          }));
    Curry._1(addCancelCallback, match[1]);
    return Curry._1(match[0], undefined);
  }
  var tagName = selectorNode.tagName;
  return Util$SmartcutsMacros.Shortcut.promise((function (param) {
                  var value = param[1];
                  var key = param[0];
                  if (!isHtmlAttributeUsefulInOptimization(key, value)) {
                    return Promise.resolve(undefined);
                  }
                  var selectorNodeToTry_classNames = [];
                  var selectorNodeToTry_attributes = [[
                      key,
                      value
                    ]];
                  var selectorNodeToTry_attributeBlacklist = [];
                  var selectorNodeToTry = {
                    id: undefined,
                    tagName: tagName,
                    classNames: selectorNodeToTry_classNames,
                    attributes: selectorNodeToTry_attributes,
                    index: undefined,
                    innerText: /* NoInnerText */1,
                    isScrollable: undefined,
                    attributeBlacklist: selectorNodeToTry_attributeBlacklist
                  };
                  var cssSelector = SelectorTree$SmartcutsMacros.stringify(queryRoot !== /* Document */0, {
                        hd: selectorNodeToTry,
                        tl: /* [] */0
                      });
                  var match = withQuerySelectorAll(undefined, context, queryRoot, undefined, cssSelector, (function (addCancelCallback, results) {
                          return onlyKeepVisibleElements(context, addCancelCallback, results).then(function (elements) {
                                      var length = elements.length;
                                      if (length !== 0 && !(length !== 1 && !(length <= 2 && !isLeafNode))) {
                                        return Promise.resolve({
                                                    TAG: /* Ok */0,
                                                    _0: elements
                                                  });
                                      } else {
                                        return Promise.resolve({
                                                    TAG: /* Ok */0,
                                                    _0: undefined
                                                  });
                                      }
                                    });
                        }));
                  Curry._1(addCancelCallback, match[1]);
                  return PromiseUtils$SmartcutsMacros.map(Curry._1(match[0], undefined), (function (result_maybeElements) {
                                if (result_maybeElements.TAG !== /* Ok */0) {
                                  return {
                                          TAG: /* Error */1,
                                          _0: result_maybeElements._0
                                        };
                                }
                                var elements = result_maybeElements._0;
                                if (elements !== undefined) {
                                  return {
                                          TAG: /* Ok */0,
                                          _0: elements
                                        };
                                }
                                
                              }));
                }), selectorNode.attributes).then(function (maybe_resultElements) {
              if (maybe_resultElements !== undefined) {
                if (maybe_resultElements.TAG === /* Ok */0) {
                  return Promise.resolve({
                              TAG: /* Ok */0,
                              _0: [
                                true,
                                maybe_resultElements._0
                              ]
                            });
                } else {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: maybe_resultElements._0
                            });
                }
              } else {
                return Promise.resolve({
                            TAG: /* Ok */0,
                            _0: [
                              false,
                              []
                            ]
                          });
              }
            });
}

function findNestedNodesToStartSearch(context, queryRoot, selector, addCancelCallback) {
  if (List.length(selector) === 1) {
    return Promise.resolve({
                TAG: /* Ok */0,
                _0: [
                  undefined,
                  selector
                ]
              });
  } else {
    return Belt_List.reduceReverse(selector, Promise.resolve({
                    TAG: /* Ok */0,
                    _0: [
                      undefined,
                      /* [] */0
                    ]
                  }), (function (prevPromise, selectorNode) {
                  return prevPromise.then(function (prevResult) {
                              if (prevResult.TAG !== /* Ok */0) {
                                return Promise.resolve({
                                            TAG: /* Error */1,
                                            _0: prevResult._0
                                          });
                              }
                              var match = prevResult._0;
                              if (match[0] !== undefined) {
                                return Promise.resolve(prevResult);
                              }
                              var prevSelector = match[1];
                              return PromiseUtils$SmartcutsMacros.makePromiseCancelableBySurroundingPromise(addCancelCallback, (function (addCancelCallback) {
                                            return isSelectorNodeOptimalToBecomeNewQueryRoot(context, queryRoot, List.length(prevSelector) === 0, addCancelCallback, selectorNode).then(function (result_pair) {
                                                        if (result_pair.TAG !== /* Ok */0) {
                                                          return Promise.resolve({
                                                                      TAG: /* Error */1,
                                                                      _0: result_pair._0
                                                                    });
                                                        }
                                                        var match = result_pair._0;
                                                        if (match[0]) {
                                                          return Promise.resolve({
                                                                      TAG: /* Ok */0,
                                                                      _0: [
                                                                        match[1],
                                                                        prevSelector
                                                                      ]
                                                                    });
                                                        } else {
                                                          return Promise.resolve({
                                                                      TAG: /* Ok */0,
                                                                      _0: [
                                                                        undefined,
                                                                        {
                                                                          hd: selectorNode,
                                                                          tl: prevSelector
                                                                        }
                                                                      ]
                                                                    });
                                                        }
                                                      });
                                          }));
                            });
                }));
  }
}

function startComboSearchForSelectorNode(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, backtrace, stack, selectorNode, recursiveSearch, addCancelCallback, remainder) {
  var match = factorOutRequiredAttributesFromNode(selectorNode);
  var selectorNodeWithoutRequiredAttributes = match[1];
  var requiredAttributes = match[0];
  return maybeFindMatch(useInnerTextExactMatch, maybeInnerTextSemantic, /* ByTagAndId */0, requiredAttributes, context, queryRoot, addCancelCallback, selectorNodeWithoutRequiredAttributes).then(function (result_found) {
              if (result_found.TAG !== /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: result_found._0
                          });
              }
              var match = result_found._0;
              if (!match) {
                return Curry._5(backtrace, useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, stack);
              }
              var match$1 = match._0;
              var nextQueryRoot_0 = match$1.element;
              var nextQueryRoot = {
                TAG: /* Element */0,
                _0: nextQueryRoot_0,
                _1: undefined
              };
              return Curry._6(recursiveSearch, useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                          queryRoot: nextQueryRoot,
                          stack: {
                            hd: {
                              selectorNodeWithoutRequiredAttributes: selectorNodeWithoutRequiredAttributes,
                              requiredAttributes: requiredAttributes,
                              queryRoot: nextQueryRoot,
                              fallbackStrategy: match$1.fallbackStrategy,
                              selector: remainder
                            },
                            tl: stack
                          }
                        }, remainder);
            });
}

function recursiveSearch_(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, param, selector) {
  var stack = param.stack;
  var queryRoot = param.queryRoot;
  if (selector) {
    var remainder = selector.tl;
    var selectorNode = selector.hd;
    var cssSelector = SelectorTree$SmartcutsMacros.stringify(queryRoot !== /* Document */0, {
          hd: selectorNode,
          tl: /* [] */0
        });
    var match = withQuerySelectorAll(undefined, context, queryRoot, undefined, cssSelector, (function (addCancelCallback, results) {
            return onlyKeepVisibleElementsOrOptionElements(context, addCancelCallback, results).then(function (resultElements) {
                        var _twoOrMore = resultElements.length;
                        if (_twoOrMore === 0) {
                          return startComboSearchForSelectorNode(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, backtrace, stack, selectorNode, recursiveSearch, addCancelCallback, remainder);
                        }
                        if (_twoOrMore !== 1) {
                          return keepElementsThatIncludeInnerText(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, resultElements).then(function (elementsThatIncludeInnerText) {
                                      var _twoOrMore = elementsThatIncludeInnerText.length;
                                      if (_twoOrMore === 0) {
                                        return startComboSearchForSelectorNode(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, backtrace, stack, selectorNode, recursiveSearch, addCancelCallback, remainder);
                                      }
                                      if (_twoOrMore === 1) {
                                        return Promise.resolve({
                                                    TAG: /* Ok */0,
                                                    _0: Caml_option.some(Caml_array.get(elementsThatIncludeInnerText, 0))
                                                  });
                                      }
                                      var match = factorOutRequiredAttributesFromNode(selectorNode);
                                      var selectorNodeWithoutRequiredAttributes = match[1];
                                      var requiredAttributes = match[0];
                                      return Util$SmartcutsMacros.shortcutPromise((function (element) {
                                                      return PromiseUtils$SmartcutsMacros.map(recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                                                                      queryRoot: {
                                                                        TAG: /* Element */0,
                                                                        _0: element,
                                                                        _1: undefined
                                                                      },
                                                                      stack: {
                                                                        hd: {
                                                                          selectorNodeWithoutRequiredAttributes: selectorNodeWithoutRequiredAttributes,
                                                                          requiredAttributes: requiredAttributes,
                                                                          queryRoot: queryRoot,
                                                                          fallbackStrategy: /* ByTagAndId */0,
                                                                          selector: remainder
                                                                        },
                                                                        tl: stack
                                                                      }
                                                                    }, remainder), (function (result_maybeResult) {
                                                                    if (result_maybeResult.TAG !== /* Ok */0) {
                                                                      return {
                                                                              TAG: /* Error */1,
                                                                              _0: result_maybeResult._0
                                                                            };
                                                                    }
                                                                    var result_ = result_maybeResult._0;
                                                                    if (result_ !== undefined) {
                                                                      return {
                                                                              TAG: /* Ok */0,
                                                                              _0: Caml_option.valFromOption(result_)
                                                                            };
                                                                    }
                                                                    
                                                                  }));
                                                    }), elementsThatIncludeInnerText).then(function (maybe_result_Element) {
                                                  if (maybe_result_Element !== undefined) {
                                                    if (maybe_result_Element.TAG === /* Ok */0) {
                                                      return Promise.resolve({
                                                                  TAG: /* Ok */0,
                                                                  _0: Caml_option.some(maybe_result_Element._0)
                                                                });
                                                    } else {
                                                      return Promise.resolve({
                                                                  TAG: /* Error */1,
                                                                  _0: maybe_result_Element._0
                                                                });
                                                    }
                                                  } else {
                                                    return startComboSearchForSelectorNode(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, backtrace, stack, selectorNode, recursiveSearch, addCancelCallback, remainder);
                                                  }
                                                });
                                    });
                        }
                        var match = factorOutRequiredAttributesFromNode(selectorNode);
                        return recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                                    queryRoot: {
                                      TAG: /* Element */0,
                                      _0: Caml_array.get(resultElements, 0),
                                      _1: undefined
                                    },
                                    stack: {
                                      hd: {
                                        selectorNodeWithoutRequiredAttributes: match[1],
                                        requiredAttributes: match[0],
                                        queryRoot: queryRoot,
                                        fallbackStrategy: /* ByTagAndId */0,
                                        selector: remainder
                                      },
                                      tl: stack
                                    }
                                  }, remainder);
                      });
          }));
    Curry._1(addCancelCallback, match[1]);
    return Curry._1(match[0], undefined);
  }
  if (typeof queryRoot === "number") {
    return Promise.resolve({
                TAG: /* Ok */0,
                _0: undefined
              });
  }
  var element = queryRoot._0;
  if (useInnerTextExactMatch === undefined) {
    return Promise.resolve({
                TAG: /* Ok */0,
                _0: Caml_option.some(element)
              });
  }
  var arg = Caml_option.some(element);
  return PromiseUtils$SmartcutsMacros.map((function (param) {
                  return OptionUtils$SmartcutsMacros.keepAsync(param, arg);
                })(function (param) {
                  return doesElementMatchInnerText(useInnerTextExactMatch, maybeInnerTextSemantic, context, (function (text, expectedText) {
                                return text === expectedText;
                              }), (function (text, expectedPrefix, param) {
                                return text.startsWith(expectedPrefix);
                              }), (function (prefix, param, expectedText) {
                                return expectedText.startsWith(prefix);
                              }), (function (prefix, param, expectedPrefix, param$1) {
                                return prefix.startsWith(expectedPrefix);
                              }), addCancelCallback, param);
                }), (function (maybeElement) {
                return {
                        TAG: /* Ok */0,
                        _0: maybeElement
                      };
              }));
}

function recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, state, selectorAndSearchScope) {
  return PromiseUtils$SmartcutsMacros.withTimeout(0, recursiveSearch_(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, state, selectorAndSearchScope));
}

function backtrace(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, stack) {
  if (!stack) {
    return Promise.resolve({
                TAG: /* Ok */0,
                _0: undefined
              });
  }
  var prevBreakpoints = stack.tl;
  var lastBreakpoint = stack.hd;
  var selector = lastBreakpoint.selector;
  return maybeFindMatch(useInnerTextExactMatch, maybeInnerTextSemantic, lastBreakpoint.fallbackStrategy, lastBreakpoint.requiredAttributes, context, lastBreakpoint.queryRoot, addCancelCallback, lastBreakpoint.selectorNodeWithoutRequiredAttributes).then(function (result_results) {
              if (result_results.TAG !== /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: result_results._0
                          });
              }
              var match = result_results._0;
              if (!match) {
                return backtrace(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, prevBreakpoints);
              }
              var match$1 = match._0;
              return recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                          queryRoot: {
                            TAG: /* Element */0,
                            _0: match$1.element,
                            _1: undefined
                          },
                          stack: {
                            hd: {
                              selectorNodeWithoutRequiredAttributes: lastBreakpoint.selectorNodeWithoutRequiredAttributes,
                              requiredAttributes: lastBreakpoint.requiredAttributes,
                              queryRoot: lastBreakpoint.queryRoot,
                              fallbackStrategy: match$1.fallbackStrategy,
                              selector: lastBreakpoint.selector
                            },
                            tl: prevBreakpoints
                          }
                        }, selector);
            });
}

function attemptToFindDeepestNode(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, addCancelCallback, selector) {
  Curry._1(Log$SmartcutsMacros.selector.log1, "Searching via deepest node");
  var maybePromisedResult = OptionUtils$SmartcutsMacros.map(Belt_List.get(List.rev(selector), 0), (function (deepestNode) {
          return recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                      queryRoot: queryRoot,
                      stack: /* [] */0
                    }, {
                      hd: deepestNode,
                      tl: /* [] */0
                    });
        }));
  return OptionUtils$SmartcutsMacros.withDefault(Promise.resolve({
                  TAG: /* Ok */0,
                  _0: undefined
                }), maybePromisedResult);
}

function topDownSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, selector, addCancelCallback) {
  var match = PromiseUtils$SmartcutsMacros.withRetries(3, (function (addCancelCallback, param) {
          Curry._1(Log$SmartcutsMacros.selector.log1, "Searching via deepest node");
          return findNestedNodesToStartSearch(context, queryRoot, selector, addCancelCallback).then(function (result) {
                      if (result.TAG !== /* Ok */0) {
                        return Promise.resolve({
                                    TAG: /* Error */1,
                                    _0: result._0
                                  });
                      }
                      var match = result._0;
                      var selector = match[1];
                      var maybeOptimalStartElements = match[0];
                      Curry._1(Log$SmartcutsMacros.selector.log1, "Searching via deepest node - nested nodes");
                      Curry._3(Log$SmartcutsMacros.selector.log3, "results", maybeOptimalStartElements, $$Array.of_list(selector));
                      if (maybeOptimalStartElements === undefined) {
                        return recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                                    queryRoot: queryRoot,
                                    stack: /* [] */0
                                  }, selector);
                      }
                      if (!selector && maybeOptimalStartElements.length === 1) {
                        return recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                                    queryRoot: {
                                      TAG: /* Element */0,
                                      _0: Caml_array.get(maybeOptimalStartElements, 0),
                                      _1: undefined
                                    },
                                    stack: /* [] */0
                                  }, selector);
                      }
                      return Util$SmartcutsMacros.Shortcut.promise((function (element) {
                                      return PromiseUtils$SmartcutsMacros.map(recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                                                      queryRoot: {
                                                        TAG: /* Element */0,
                                                        _0: element,
                                                        _1: undefined
                                                      },
                                                      stack: /* [] */0
                                                    }, selector), (function (result_maybeElement) {
                                                    if (result_maybeElement.TAG !== /* Ok */0) {
                                                      return {
                                                              TAG: /* Error */1,
                                                              _0: result_maybeElement._0
                                                            };
                                                    }
                                                    var element = result_maybeElement._0;
                                                    if (element !== undefined) {
                                                      return {
                                                              TAG: /* Ok */0,
                                                              _0: Caml_option.valFromOption(element)
                                                            };
                                                    }
                                                    
                                                  }));
                                    }), maybeOptimalStartElements).then(function (maybe_result_element) {
                                  if (maybe_result_element !== undefined) {
                                    if (maybe_result_element.TAG === /* Ok */0) {
                                      return Promise.resolve({
                                                  TAG: /* Ok */0,
                                                  _0: Caml_option.some(maybe_result_element._0)
                                                });
                                    } else {
                                      return Promise.resolve({
                                                  TAG: /* Error */1,
                                                  _0: maybe_result_element._0
                                                });
                                    }
                                  } else {
                                    return recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                                                queryRoot: queryRoot,
                                                stack: /* [] */0
                                              }, selector);
                                  }
                                });
                    });
        }), (function (param) {
          return false;
        }), {
        TAG: /* Ok */0,
        _0: undefined
      }, undefined);
  Curry._1(addCancelCallback, match[1]);
  return Curry._1(match[0], undefined);
}

function shouldOnlySearchViaInnerText(selector) {
  var match = SelectorTree$SmartcutsMacros.maybeGetLeafNode(selector);
  if (match !== undefined && typeof match.innerText !== "number") {
    return true;
  } else {
    return false;
  }
}

function scrollVerticallyToLoadAllElements(context, scrollableElement) {
  var loop = function (clientHeight, lastScrollHeight) {
    return Promise.resolve(scrollableElement.scrollHeight).then(function (scrollHeight) {
                if (scrollHeight <= lastScrollHeight) {
                  return Util$SmartcutsMacros.wait(120).then(function (param) {
                              return Promise.resolve(scrollableElement.scrollHeight).then(function (scrollHeight_2) {
                                          if (scrollHeight_2 <= lastScrollHeight) {
                                            return Promise.resolve(undefined);
                                          }
                                          var func = function (param, param$1, param$2) {
                                            return scrollTo(context, param, param$1, param$2);
                                          };
                                          var arg = scrollHeight_2 - clientHeight | 0;
                                          return func(undefined, arg, scrollableElement).then(function (param) {
                                                      return loop(clientHeight, scrollHeight_2);
                                                    });
                                        });
                            });
                }
                var func = function (param, param$1, param$2) {
                  return scrollTo(context, param, param$1, param$2);
                };
                var arg = scrollHeight - clientHeight | 0;
                return func(undefined, arg, scrollableElement).then(function (param) {
                            return loop(clientHeight, scrollHeight);
                          });
              });
  };
  return Promise.all([
                Promise.resolve(scrollableElement.scrollHeight),
                Promise.resolve(scrollableElement.clientHeight)
              ]).then(function (param) {
              var clientHeight = param[1];
              var scrollHeight = param[0];
              var func = function (param, param$1, param$2) {
                return scrollTo(context, param, param$1, param$2);
              };
              var arg = scrollHeight - clientHeight | 0;
              return func(undefined, arg, scrollableElement).then(function (param) {
                          return loop(clientHeight, scrollHeight);
                        });
            });
}

function findChainWithLowestScoreAndAnyTiedChains(chainDistancePairs) {
  return ArrayUtils$SmartcutsMacros.splitAtFirstExn("Expect to get Some(chainWithLowestScore)", ArrayUtils$SmartcutsMacros.filterMap((function (param) {
                    var distance = param[1];
                    if (Belt_Array.every(chainDistancePairs, (function (param) {
                              return param[1] >= distance;
                            }))) {
                      return param[0];
                    }
                    
                  }), chainDistancePairs));
}

function search1(useInnerText, maybeInnerTextSemantic, context, queryRoot, fullSelector, addOnPredicateTimedOutCallback, maybeDomTree, maybeOnlyConsiderElementChainIf, includeElementsNotVisible, param) {
  var selectorSlices = Selector$SmartcutsMacros.splitForShadowDom(fullSelector);
  return Belt_Array.reduceWithIndex(selectorSlices, Promise.resolve({
                    TAG: /* Ok */0,
                    _0: [
                      maybeDomTree,
                      queryRoot
                    ]
                  }), (function (lastProm, selectorSlice, selectorSliceIndex) {
                  return lastProm.then(function (result_pair) {
                              if (result_pair.TAG !== /* Ok */0) {
                                return Promise.resolve({
                                            TAG: /* Error */1,
                                            _0: result_pair._0
                                          });
                              }
                              var match = result_pair._0;
                              var maybeQueryRoot = match[1];
                              var maybeDomTree = match[0];
                              if (maybeQueryRoot === undefined) {
                                return Promise.resolve({
                                            TAG: /* Ok */0,
                                            _0: [
                                              maybeDomTree,
                                              maybeQueryRoot
                                            ]
                                          });
                              }
                              var match$1 = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, param) {
                                    var isLastSlice = selectorSliceIndex === (selectorSlices.length - 1 | 0);
                                    return init(useInnerText && isLastSlice, maybeInnerTextSemantic, maybeQueryRoot, context, addCancelCallback, maybeDomTree, maybeOnlyConsiderElementChainIf, includeElementsNotVisible, selectorSlice).then(function (result_chainsAndTree) {
                                                if (result_chainsAndTree.TAG !== /* Ok */0) {
                                                  return Promise.resolve({
                                                              TAG: /* Error */1,
                                                              _0: result_chainsAndTree._0
                                                            });
                                                }
                                                var match = result_chainsAndTree._0;
                                                var domTree = match[1];
                                                var elementChains = match[0];
                                                if (elementChains.length === 0) {
                                                  return Promise.resolve({
                                                              TAG: /* Ok */0,
                                                              _0: [
                                                                Caml_option.some(domTree),
                                                                undefined
                                                              ]
                                                            });
                                                }
                                                var func = function (param, param$1, param$2) {
                                                  return Promise.all(Belt_Array.map(param$2, (function (elementChain) {
                                                                    return PromiseUtils$SmartcutsMacros.resolveWith((function (distance) {
                                                                                  return [
                                                                                          elementChain,
                                                                                          distance
                                                                                        ];
                                                                                }), calcForElementChain(domTree, param, param$1, elementChain));
                                                                  })));
                                                };
                                                var func$1 = Curry._1(func, selectorSlice);
                                                return Curry._1((function (param) {
                                                                return Curry._2(func$1, param, elementChains);
                                                              }), context).then(function (chainDistancePairs) {
                                                            var func = function (param, param$1) {
                                                              var match = findChainWithLowestScoreAndAnyTiedChains(param$1);
                                                              var chainWithLowestScore = match[0];
                                                              var tiedChains = match[1];
                                                              return Belt_Array.reduce(tiedChains, chainWithLowestScore, (function (currBestChain, currChain) {
                                                                            var maybeNextBestChain = ListUtils$SmartcutsMacros.shortcutWithIndex((function (selectorNode, nodeIndex) {
                                                                                    var maybeRecordedSiblingIndex = selectorNode.index;
                                                                                    var currElementA = Caml_array.get(currBestChain, nodeIndex);
                                                                                    var currElementB = Caml_array.get(currChain, nodeIndex);
                                                                                    var siblingIndexA = getSiblingIndex(param, currElementA);
                                                                                    var siblingIndexB = getSiblingIndex(param, currElementB);
                                                                                    if (maybeRecordedSiblingIndex !== undefined && !(maybeRecordedSiblingIndex === siblingIndexA && maybeRecordedSiblingIndex === siblingIndexB)) {
                                                                                      if (maybeRecordedSiblingIndex === siblingIndexA) {
                                                                                        return currBestChain;
                                                                                      } else if (maybeRecordedSiblingIndex === siblingIndexB) {
                                                                                        return currChain;
                                                                                      } else {
                                                                                        return ;
                                                                                      }
                                                                                    }
                                                                                    
                                                                                  }), selectorSlice);
                                                                            return OptionUtils$SmartcutsMacros.withDefault(currBestChain, maybeNextBestChain);
                                                                          }));
                                                            };
                                                            var bestChain = Curry._2(func, domTree, chainDistancePairs);
                                                            var maybeNextQueryRoot = OptionUtils$SmartcutsMacros.map(ArrayUtils$SmartcutsMacros.last(bestChain), (function (bestElement) {
                                                                    if (isLastSlice) {
                                                                      var tmp;
                                                                      if (typeof maybeQueryRoot === "number") {
                                                                        tmp = bestChain.length;
                                                                      } else if (maybeQueryRoot.TAG === /* Element */0) {
                                                                        var depth = maybeQueryRoot._1;
                                                                        tmp = depth !== undefined ? depth + bestChain.length | 0 : bestChain.length;
                                                                      } else {
                                                                        tmp = maybeQueryRoot._1 + bestChain.length | 0;
                                                                      }
                                                                      return {
                                                                              TAG: /* Element */0,
                                                                              _0: bestElement,
                                                                              _1: tmp
                                                                            };
                                                                    }
                                                                    var arg = Caml_option.some(bestElement.shadowRoot);
                                                                    var tmp$1;
                                                                    if (typeof maybeQueryRoot === "number") {
                                                                      tmp$1 = bestChain.length + 1 | 0;
                                                                    } else if (maybeQueryRoot.TAG === /* Element */0) {
                                                                      var depth$1 = maybeQueryRoot._1;
                                                                      tmp$1 = depth$1 !== undefined ? (depth$1 + bestChain.length | 0) + 1 | 0 : bestChain.length + 1 | 0;
                                                                    } else {
                                                                      tmp$1 = (maybeQueryRoot._1 + bestChain.length | 0) + 1 | 0;
                                                                    }
                                                                    return {
                                                                            TAG: /* ShadowRoot */1,
                                                                            _0: (function (param) {
                                                                                  return OptionUtils$SmartcutsMacros.getExn(param, arg);
                                                                                })("Expected dom shadow root"),
                                                                            _1: tmp$1
                                                                          };
                                                                  }));
                                                            return Promise.resolve({
                                                                        TAG: /* Ok */0,
                                                                        _0: [
                                                                          Caml_option.some(domTree),
                                                                          maybeNextQueryRoot
                                                                        ]
                                                                      });
                                                          });
                                              });
                                  });
                              Curry._1(addOnPredicateTimedOutCallback, match$1[1]);
                              return Curry._1(match$1[0], undefined);
                            });
                })).then(function (result) {
              if (result.TAG !== /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: result._0
                          });
              }
              var maybeQueryRoot = result._0[1];
              if (maybeQueryRoot !== undefined && typeof maybeQueryRoot !== "number") {
                return Promise.resolve({
                            TAG: /* Ok */0,
                            _0: Caml_option.some(maybeQueryRoot._0)
                          });
              } else {
                return Promise.resolve({
                            TAG: /* Ok */0,
                            _0: undefined
                          });
              }
            });
}

function searchWithScrolling(useInnerText, maybeInnerTextSemantic, context, queryRoot, selector, addOnPredicateTimedOutCallback, domTree, onlyConsiderElementChainIf, includeElementsNotVisible, param) {
  return search1(useInnerText, maybeInnerTextSemantic, context, queryRoot, selector, addOnPredicateTimedOutCallback, domTree, onlyConsiderElementChainIf, includeElementsNotVisible, undefined).then(function (result) {
              if (result.TAG !== /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: result._0
                          });
              }
              if (result._0 !== undefined) {
                return Promise.resolve(result);
              }
              if (!useInnerText) {
                return Promise.resolve({
                            TAG: /* Ok */0,
                            _0: undefined
                          });
              }
              var selectorDepth = Belt_List.length(selector);
              return Belt_List.reduceWithIndex(Belt_List.reverse(selector), Promise.resolve({
                              TAG: /* Ok */0,
                              _0: undefined
                            }), (function (promise, selectorNode, index) {
                            return promise.then(function (result_maybeResult) {
                                        if (result_maybeResult.TAG !== /* Ok */0) {
                                          return Promise.resolve({
                                                      TAG: /* Error */1,
                                                      _0: result_maybeResult._0
                                                    });
                                        }
                                        var element = result_maybeResult._0;
                                        if (element !== undefined) {
                                          return Promise.resolve({
                                                      TAG: /* Ok */0,
                                                      _0: Caml_option.some(Caml_option.valFromOption(element))
                                                    });
                                        }
                                        if (selectorNode.isScrollable === undefined || Caml_obj.caml_equal(selectorNode.isScrollable, false)) {
                                          return Promise.resolve({
                                                      TAG: /* Ok */0,
                                                      _0: undefined
                                                    });
                                        }
                                        var indexOfLastScrollableElement = selectorDepth - index | 0;
                                        var arg = Belt_List.take(selector, indexOfLastScrollableElement);
                                        var selectorToScrollableElement = (function (param) {
                                              return OptionUtils$SmartcutsMacros.getExn(param, arg);
                                            })("Expect to get selectorToScrollableElement");
                                        var arg$1 = Belt_List.drop(selector, indexOfLastScrollableElement);
                                        var selectorFromScrollableElement = (function (param) {
                                              return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                                            })("Expect to get selectorFromScrollableElement");
                                        return search1(useInnerText, maybeInnerTextSemantic, context, queryRoot, selectorToScrollableElement, addOnPredicateTimedOutCallback, domTree, onlyConsiderElementChainIf, includeElementsNotVisible, undefined).then(function (result_maybeElement) {
                                                    if (result_maybeElement.TAG !== /* Ok */0) {
                                                      return Promise.resolve({
                                                                  TAG: /* Error */1,
                                                                  _0: result_maybeElement._0
                                                                });
                                                    }
                                                    var scrollableElement = result_maybeElement._0;
                                                    if (scrollableElement === undefined) {
                                                      return Promise.resolve({
                                                                  TAG: /* Ok */0,
                                                                  _0: undefined
                                                                });
                                                    }
                                                    var scrollableElement$1 = Caml_option.valFromOption(scrollableElement);
                                                    return scrollVerticallyToLoadAllElements(context, scrollableElement$1).then(function (param) {
                                                                return search1(useInnerText, maybeInnerTextSemantic, context, {
                                                                            TAG: /* Element */0,
                                                                            _0: scrollableElement$1,
                                                                            _1: indexOfLastScrollableElement
                                                                          }, selectorFromScrollableElement, addOnPredicateTimedOutCallback, domTree, onlyConsiderElementChainIf, includeElementsNotVisible, undefined);
                                                              });
                                                  });
                                      });
                          }));
            });
}

function search2(useInnerText, maybeInnerTextSemantic, context, queryRoot, selector, addOnPredicateTimedOutCallback) {
  if (useInnerText && shouldOnlySearchViaInnerText(selector)) {
    Curry._1(Log$SmartcutsMacros.selector.log1, "Searching via innerText");
    var match = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, param) {
          var selectorReversed = List.rev(selector);
          return OptionUtils$SmartcutsMacros.withDefault(Promise.resolve({
                          TAG: /* Ok */0,
                          _0: undefined
                        }), Belt_Option.map(Belt_List.get(selectorReversed, 0), (function (param) {
                            var innerText = param.innerText;
                            var maybeTagName = param.tagName;
                            if (typeof innerText === "number") {
                              return Promise.resolve({
                                          TAG: /* Ok */0,
                                          _0: undefined
                                        });
                            }
                            if (maybeTagName === undefined) {
                              return Promise.resolve({
                                          TAG: /* Ok */0,
                                          _0: undefined
                                        });
                            }
                            if (innerText._0.trim() === "") {
                              return Promise.resolve({
                                          TAG: /* Ok */0,
                                          _0: undefined
                                        });
                            }
                            var normalizedTextCriteria = $$String.lowercase_ascii(innerText._0.trim());
                            var applyToAppropriateElements = maybeTagName === "a" ? XPath$SmartcutsMacros.ExpressionBuilder.elementWithOrDescendantElementsWith : (function (builder) {
                                  return builder;
                                });
                            var xpath = "//" + (maybeTagName + ("[" + (Curry._1(applyToAppropriateElements, XPath$SmartcutsMacros.ExpressionBuilder.equals(normalizedTextCriteria, XPath$SmartcutsMacros.ExpressionBuilder.lowercase(XPath$SmartcutsMacros.ExpressionBuilder.normalizeSpace(XPath$SmartcutsMacros.ExpressionBuilder.text)))) + "]")));
                            return queryXPath(context, queryRoot, addCancelCallback, xpath).then(function (elements) {
                                          Curry._3(Log$SmartcutsMacros.selector.log3, "xpath", xpath, elements);
                                          var len = elements.length;
                                          if (len !== 1) {
                                            if (len !== 0) {
                                              return Promise.resolve(Caml_option.some(undefined)).then(function (maybeDomTree) {
                                                          var getParentElements$1 = function (elements) {
                                                            if (maybeDomTree !== undefined) {
                                                              return getParentElements(Caml_option.valFromOption(maybeDomTree), elements);
                                                            } else {
                                                              return Belt_Array.map(elements, (function (param) {
                                                                            
                                                                          }));
                                                            }
                                                          };
                                                          return Util$SmartcutsMacros.shortcutPromise((function (maybeParentElement) {
                                                                        var match = ListUtils$SmartcutsMacros.getLast(selector);
                                                                        var match$1 = Belt_List.get(selectorReversed, 1);
                                                                        if (maybeParentElement === undefined) {
                                                                          return Promise.resolve(undefined);
                                                                        }
                                                                        if (match === undefined) {
                                                                          return Promise.resolve(undefined);
                                                                        }
                                                                        if (match$1 === undefined) {
                                                                          return Promise.resolve(undefined);
                                                                        }
                                                                        var parentElement = Caml_option.valFromOption(maybeParentElement);
                                                                        return couldElementMatchSelectorTreeNode(context, parentElement, match$1).then(function (couldMatch) {
                                                                                    if (couldMatch) {
                                                                                      return PromiseUtils$SmartcutsMacros.map(topDownSearch(innerText, maybeInnerTextSemantic, context, {
                                                                                                      TAG: /* Element */0,
                                                                                                      _0: parentElement,
                                                                                                      _1: undefined
                                                                                                    }, {
                                                                                                      hd: match,
                                                                                                      tl: /* [] */0
                                                                                                    }, addCancelCallback), (function (result_maybe_element) {
                                                                                                    if (result_maybe_element.TAG !== /* Ok */0) {
                                                                                                      return {
                                                                                                              TAG: /* Error */1,
                                                                                                              _0: result_maybe_element._0
                                                                                                            };
                                                                                                    }
                                                                                                    var element = result_maybe_element._0;
                                                                                                    if (element !== undefined) {
                                                                                                      return {
                                                                                                              TAG: /* Ok */0,
                                                                                                              _0: Caml_option.valFromOption(element)
                                                                                                            };
                                                                                                    }
                                                                                                    
                                                                                                  }));
                                                                                    } else {
                                                                                      return Promise.resolve(undefined);
                                                                                    }
                                                                                  });
                                                                      }), getParentElements$1(elements));
                                                        });
                                            } else {
                                              return Promise.resolve(undefined);
                                            }
                                          }
                                          var onlyElement = elements[0];
                                          return Promise.resolve({
                                                      TAG: /* Ok */0,
                                                      _0: onlyElement
                                                    });
                                        }).then(function (maybeResultElement) {
                                        if (maybeResultElement !== undefined) {
                                          if (maybeResultElement.TAG === /* Ok */0) {
                                            return Promise.resolve({
                                                        TAG: /* Ok */0,
                                                        _0: Caml_option.some(maybeResultElement._0)
                                                      });
                                          } else {
                                            return Promise.resolve({
                                                        TAG: /* Error */1,
                                                        _0: maybeResultElement._0
                                                      });
                                          }
                                        }
                                        var useInnerTextExactMatch = OptionUtils$SmartcutsMacros.andThen((function (leafNode) {
                                                var match = leafNode.innerText;
                                                if (typeof match === "number") {
                                                  return ;
                                                } else {
                                                  return match;
                                                }
                                              }), SelectorTree$SmartcutsMacros.maybeGetLeafNode(selector));
                                        return attemptToFindDeepestNode(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, addCancelCallback, selector).then(function (result_maybeElement) {
                                                    if (result_maybeElement.TAG !== /* Ok */0) {
                                                      return Promise.resolve({
                                                                  TAG: /* Error */1,
                                                                  _0: result_maybeElement._0
                                                                });
                                                    }
                                                    var element = result_maybeElement._0;
                                                    if (element !== undefined) {
                                                      return Promise.resolve({
                                                                  TAG: /* Ok */0,
                                                                  _0: Caml_option.some(Caml_option.valFromOption(element))
                                                                });
                                                    } else {
                                                      return topDownSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, selector, addCancelCallback);
                                                    }
                                                  });
                                      });
                          })));
        });
    Curry._1(addOnPredicateTimedOutCallback, match[1]);
    return Curry._1(match[0], undefined);
  }
  var match$1 = PromiseUtils$SmartcutsMacros.makeCancelable(function (addCancelCallback, param) {
        return attemptToFindDeepestNode(undefined, undefined, context, queryRoot, addCancelCallback, selector).then(function (result_maybeResult) {
                    if (result_maybeResult.TAG !== /* Ok */0) {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: result_maybeResult._0
                                });
                    }
                    var element = result_maybeResult._0;
                    if (element !== undefined) {
                      return Promise.resolve({
                                  TAG: /* Ok */0,
                                  _0: Caml_option.some(Caml_option.valFromOption(element))
                                });
                    } else {
                      return topDownSearch(undefined, maybeInnerTextSemantic, context, queryRoot, selector, addCancelCallback);
                    }
                  });
      });
  Curry._1(addOnPredicateTimedOutCallback, match$1[1]);
  return Curry._1(match$1[0], undefined);
}

var QueryInWebPage_CandidateBranches = {
  ElementChain: {},
  init: init
};

var QueryInWebPage = {
  CandidateBranches: QueryInWebPage_CandidateBranches,
  search1: search1,
  searchWithScrolling: searchWithScrolling,
  search2: search2
};

exports.candidateBranch_encode = candidateBranch_encode;
exports.candidateBranch_decode = candidateBranch_decode;
exports.MakeQueryInPromise = MakeQueryInPromise;
exports.WebPage = WebPage;
exports.QueryInWebPage = QueryInWebPage;
/* fast-levenshtein Not a pure module */
